<ng-helmet>
  <title>Terms & Conditions | Uptal</title>
</ng-helmet>
<main-header [darkMode]="true"></main-header>

<!-- English -->
<div class="legal-page pt-28" dir="ltr" lang="en" *ngIf="!isArabic">
  <div class="hero">
    <span class="eyebrow"
      ><span aria-hidden="true" class="dot"></span> Terms &amp; Conditions</span
    >
    <h1>Terms &amp; Conditions</h1>
    <p class="lede">
      These Terms govern your use of the Uptal website, platform, and all Uptal
      services: Talent Search, interviews and assessments for employers, and
      Auto-Apply and CV Enhancer for job seekers.
    </p>
    <div class="meta">
      <span><b>Last updated:</b> September 7, 2026 </span
      ><span
        ><b>Provider:</b> Uptal (شركة الخبرات الصاعدة لتقنية المعلومات), Kingdom
        of Saudi Arabia</span
      >
    </div>
  </div>
  <div class="wrap">
    <nav aria-label="On this page" class="toc">
      <div class="inner">
        <h4>On this page</h4>
        <ol>
          <li>
            <a [routerLink]="[]" fragment="acceptance"
              >Acceptance of these Terms</a
            >
          </li>
          <li><a [routerLink]="[]" fragment="definitions">Definitions</a></li>
          <li><a [routerLink]="[]" fragment="eligibility">Eligibility</a></li>
          <li><a [routerLink]="[]" fragment="services">Our services</a></li>
          <li><a [routerLink]="[]" fragment="accounts">User accounts</a></li>
          <li>
            <a [routerLink]="[]" fragment="payments"
              >Payments, subscriptions &amp; refunds</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="jobseekers"
              >Job seeker services: Auto-Apply &amp; CV Enhancer</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="acceptable-use"
              >Acceptable use &amp; prohibited activities</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="ip"
              >Intellectual property &amp; licenses</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="privacy"
              >Privacy &amp; PDPL compliance</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="custodianship"
              >Data custodianship &amp; platform outputs</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="analytics"
              >Usage data &amp; analytics</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="thirdparty">Third-party services</a>
          </li>
          <li>
            <a [routerLink]="[]" fragment="termination"
              >Suspension &amp; termination</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="disclaimers"
              >Disclaimer of warranties</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="liability"
              >Limitation and exclusion of liability</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="indemnification">Indemnification</a>
          </li>
          <li>
            <a [routerLink]="[]" fragment="force-majeure">Force majeure</a>
          </li>
          <li>
            <a [routerLink]="[]" fragment="severability"
              >Severability; no waiver</a
            >
          </li>
          <li><a [routerLink]="[]" fragment="assignment">Assignment</a></li>
          <li>
            <a [routerLink]="[]" fragment="notices"
              >Notices and electronic communications</a
            >
          </li>
          <li><a [routerLink]="[]" fragment="language">Language</a></li>
          <li>
            <a [routerLink]="[]" fragment="survival"
              >Survival; entire agreement</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="law"
              >Governing law &amp; jurisdiction</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="changes">Changes to these Terms</a>
          </li>
          <li><a [routerLink]="[]" fragment="contact">Contact</a></li>
        </ol>
      </div>
    </nav>
    <article>
      <section id="acceptance">
        <h2>
          <span class="num">1</span> Acceptance of these Terms; binding effect
        </h2>
        <p>
          Welcome to Uptal (شركة الخبرات الصاعدة لتقنية المعلومات). These Terms
          and Conditions (together with all documents, policies, and schedules
          incorporated by reference herein, these "Terms") constitute a legally
          binding agreement between you and Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات) and govern your access to and use of the Uptal website,
          platform, applications, interfaces, and all services, features,
          functionality, content, and tools made available by or on behalf of
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) from time to time
          (collectively, the "Services"). By accessing, browsing, registering
          for, subscribing to, activating, or otherwise using any part of the
          Services, by clicking to accept or agree to these Terms where that
          option is presented, or by continuing to use the Services following
          any update to these Terms, you acknowledge that you have read,
          understood, and agree to be bound by, and to comply with, these Terms
          in their entirety and without modification. If you do not agree to
          these Terms, or if you are not eligible or authorized to agree to
          these Terms, you must not access or use, and must immediately cease
          all access to and use of, the Services.
        </p>
        <p>
          These Terms incorporate by reference, and shall be read together with,
          our <a routerLink="/privacy-policy">Privacy Policy</a> and our
          <a routerLink="/refund-policy">Refund Policy</a>, each as amended from
          time to time, together with any product-specific terms, order forms,
          or supplemental notices presented to you within the Services. In the
          event of any conflict or inconsistency between these Terms and any
          document incorporated by reference, these Terms shall prevail to the
          extent of such conflict or inconsistency, save that the Refund Policy
          shall prevail in respect of matters of billing, refunds, and payment
          disputes, and the Privacy Policy shall prevail in respect of the
          processing of personal data.
        </p>
        <p>
          You represent and warrant that your acceptance of, and performance
          under, these Terms does not and will not violate any other agreement
          to which you are a party, any judgment, order, or decree by which you
          are bound, or any Applicable Law.
        </p>
        <div class="note">
          Your statutory rights. Nothing in these Terms limits, excludes, or
          purports to limit or exclude any right or remedy that you have under
          the Saudi E-Commerce Law, the Consumer Protection framework, the
          Personal Data Protection Law (PDPL), or any other provision of
          Applicable Law that is mandatory and cannot be waived, limited, or
          varied by agreement, and all limitations, exclusions, authorizations,
          and acknowledgments in these Terms shall be construed accordingly and
          shall apply only to the maximum extent permitted by Applicable Law.
        </div>
      </section>
      <section id="definitions">
        <h2>
          <span class="num">2</span> Definitions and rules of interpretation
        </h2>
        <h3 class="sub">2.1 Definitions</h3>
        <p>
          In these Terms, unless the context otherwise requires, the following
          capitalized terms shall bear the following meanings:
        </p>
        <ul>
          <li>
            "Uptal", "we", "our", or "us" refers to Uptal Company (شركة الخبرات
            الصاعدة لتقنية المعلومات), Kingdom of Saudi Arabia, together with
            its successors and permitted assigns.
          </li>
          <li>
            "Services" means all products and services provided by or on behalf
            of Uptal (شركة الخبرات الصاعدة لتقنية المعلومات), including the
            Website, Talent Search, Auto-Apply, CV Enhancer, interviews,
            assessments, recruitment management software, and all associated
            features, tools, interfaces, and content, in each case as modified,
            supplemented, or discontinued from time to time.
          </li>
          <li>
            "Website" means the website located at
            <a routerLink="/">https://uptal.com</a> and any related Uptal
            websites, subdomains, or applications.
          </li>
          <li>
            "AI Systems" means the artificial intelligence, machine learning,
            statistical, algorithmic, and other automated systems, models, and
            processes used by or on behalf of Uptal (شركة الخبرات الصاعدة لتقنية
            المعلومات) in connection with the Services, including systems used
            for matching, ranking, scoring, evaluation, CV generation and
            tailoring, and the preparation and submission of Applications.
          </li>
          <li>
            "Application" means any job application, expression of interest, or
            similar submission, together with any tailored CV, cover materials,
            application details, and personal data comprised in it, prepared
            and/or submitted through the Services, and "Submission" means the
            act of transmitting an Application to any employer, applicant
            tracking system, job platform, or other recipient.
          </li>
          <li>
            "Output" or "Outputs" means any content, result, or material
            generated in whole or in part by the AI Systems, including job
            matches, match scores, rankings, evaluations, assessments, insights,
            recommendations, and tailored or enhanced CVs.
          </li>
          <li>
            "Subscriber" or "Customer" means an employer, recruiter, or hiring
            manager using the Services for recruitment purposes.
          </li>
          <li>
            "Job Seeker" means an individual using Auto-Apply, CV Enhancer, or
            any candidate-facing Uptal service.
          </li>
          <li>
            "Candidate" means an individual whose profile, CV, interview, or
            assessment is accessible through the Services.
          </li>
          <li>
            "User", "you", or "your" refers to any individual or entity
            accessing or using the Services or Website, in whatever capacity.
          </li>
          <li>
            "Applicable Law" means all laws, regulations, royal decrees,
            implementing regulations, rules, orders, and binding guidance of any
            competent authority applicable to a party or to the Services,
            including the laws of the Kingdom of Saudi Arabia, in each case as
            amended, re-enacted, or replaced from time to time.
          </li>
          <li>"Force Majeure Event" has the meaning given in Section 18.</li>
        </ul>
        <h3 class="sub">2.2 Interpretation</h3>
        <p>
          In these Terms, unless the context otherwise requires: (a) the
          headings and sub-headings are inserted for convenience of reference
          only and shall not affect the construction or interpretation of these
          Terms; (b) words importing the singular include the plural and vice
          versa; (c) the words "include", "includes", "including", and "in
          particular" shall be construed as illustrative and without limitation
          to the generality of the preceding words; (d) any reference to a law,
          regulation, or statutory provision is a reference to it as amended,
          extended, re-enacted, or replaced from time to time and includes all
          subordinate legislation made under it; (e) any reference to "writing"
          or "written" includes electronic communications; (f) where Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) has a right of determination,
          approval, consent, or discretion, such right may, to the maximum
          extent permitted by Applicable Law, be exercised in Uptal's sole and
          absolute discretion; and (g) no rule of construction shall apply to
          the disadvantage of a party on the basis that that party was
          responsible for the preparation of these Terms or any part of them.
        </p>
      </section>
      <section id="eligibility">
        <h2>
          <span class="num">3</span> Eligibility; representations as to capacity
        </h2>
        <p>
          By accessing or using the Services, you represent, warrant, and
          undertake, on a continuing basis, that: (a) you are at least eighteen
          (18) years of age; (b) you have the full legal right, power, capacity,
          and authority to enter into, and to perform your obligations under,
          these Terms; (c) if you are accessing or using the Services on behalf
          of a company, organization, or other legal entity, you are duly
          authorized to bind that entity to these Terms, in which case "you" and
          "your" shall refer to and include that entity; and (d) neither you
          nor, where applicable, such entity is prohibited or restricted from
          accessing or using the Services under any Applicable Law or by any
          prior suspension or termination effected by Uptal (شركة الخبرات
          الصاعدة لتقنية المعلومات). Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات) reserves the right, to the maximum extent permitted by
          Applicable Law, to decline any registration, to verify eligibility at
          any time, and to suspend or terminate access where any of the
          foregoing representations is or becomes untrue.
        </p>
      </section>
      <section id="services">
        <h2><span class="num">4</span> Our services</h2>
        <h3 class="sub">4.1 For employers and recruiters</h3>
        <ul>
          <li>
            <b>Talent Search</b>: subscription plans (Professional and Executive
            Pro) providing access to search, filter, and unlock verified
            candidate profiles, subject to your plan's monthly unlock allowance.
          </li>
          <li>
            <b>Interviews &amp; assessments</b>: AI-powered self-recorded
            interviews, technical assessments, and psychometric assessments that
            help companies screen candidates.
          </li>
          <li>
            <b>Recruitment management</b>: tools for managing job postings,
            applicants, and hiring pipelines.
          </li>
        </ul>
        <h3 class="sub">4.2 For job seekers</h3>
        <ul>
          <li>
            <b>Auto-Apply</b>: a recurring subscription in which Uptal's AI
            matches you to roles, tailors your CV for each role, and submits job
            applications on your behalf, according to the preferences you set.
            Auto-Apply includes an automated "Autopilot" mode in which the
            identification of roles, the tailoring of your CV, and the
            Submission of Applications occur automatically on your behalf,
            without individual review of each Application, subject to the
            authorization described in Section 7.1.
          </li>
          <li>
            <b>CV Enhancer</b>: a one-time, done-for-you service that enhances
            and rewrites your CV into a personalized digital deliverable.
          </li>
        </ul>
        <p>
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) may add, modify,
          suspend, or discontinue any feature or Service, in whole or in part,
          at any time, without notice and without liability of any kind. You may
          use the Services only for lawful purposes and in accordance with these
          Terms.
        </p>
      </section>
      <section id="accounts">
        <h2><span class="num">5</span> User accounts</h2>
        <p>
          To access certain features, you may need to register for an account.
          When you register, you agree to:
        </p>
        <ul>
          <li>
            Provide accurate, current, and complete information as prompted by
            the registration form.
          </li>
          <li>
            Maintain and promptly update your information to keep it accurate,
            current, and complete.
          </li>
          <li>
            Keep your login credentials confidential and not disclose them to
            anyone else.
          </li>
          <li>
            Be responsible for all activities that occur under your account.
          </li>
        </ul>
        <p>
          You are solely responsible for all activities, acts, and omissions
          that occur under or through your account, whether or not authorized by
          you, and Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) shall be
          entitled to treat any instruction, submission, or communication
          received through your account as having been given by you. You must
          notify us promptly, by submitting a ticket at
          <a routerLink="/contact-us">https://uptal.com/contact-us</a>, if you
          suspect any unauthorized access to or use of your account, and,
          pending such notification and Uptal's reasonable opportunity to act on
          it, you shall remain responsible for all activity under your account.
          Notice is given in the manner set out in Section 21. Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) shall not be liable for any loss or
          damage arising from any failure by you to safeguard your credentials
          or to provide such notification.
        </p>
      </section>
      <section id="payments">
        <h2>
          <span class="num">6</span> Payments, subscriptions &amp; refunds
        </h2>
        <h3 class="sub">6.1 Fees and billing</h3>
        <p>
          Certain Services require payment of fees. By using any paid Service,
          you agree to pay, and you authorize Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات) and its payment processors to charge to your selected
          payment method, all applicable fees and charges, including applicable
          taxes, at the rates in effect at the time the relevant charge is
          incurred, without set-off, deduction, or withholding. If any charge
          cannot be collected when due, Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات) may suspend or restrict the affected Service until payment
          is received in full, without prejudice to any other right or remedy.
          Subscriptions (including Talent Search and Auto-Apply) are billed on a
          recurring basis and auto-renew at the end of each billing cycle unless
          cancelled before renewal. Cancellation takes effect at the end of the
          current billing period; you retain access until your paid period
          expires. You may cancel at any time from your Uptal account settings,
          by the path Account, then Billing, then Cancel subscription.
          Cancellation is performed by the subscriber, personally, using the
          self-service cancellation function in the subscriber's own Uptal
          account settings, and that is the only means of cancelling a
          subscription. No employee, officer, agent, contractor, representative,
          reseller, automated assistant, or support team member of Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) is authorised or permitted to
          cancel, or to agree to cancel, a subscription at the request of a
          subscriber or on a subscriber's behalf, and any statement from any
          such person purporting to have cancelled a subscription, to be in the
          course of cancelling it, or to be able to cancel it is unauthorised,
          is of no effect, does not bind Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات), and does not constitute a cancellation. Submitting a
          ticket at
          <a routerLink="/contact-us">https://uptal.com/contact-us</a>, of any
          reason type and whatever the ticket says, is not a cancellation: it
          does not cancel a subscription, does not pause billing, and does not
          stop a renewal. Renewals, the renewal cut-off, what is not a
          cancellation, the position where the cancellation function was
          unavailable to your account, and the consequences of failing to cancel
          are governed by Section 4 of the Refund Policy.
        </p>
        <h3 class="sub">6.2 No refunds</h3>
        <div class="callout">
          All payments for all Uptal Services are final and non-refundable.
          Uptal's Services are digital services with immediate access and are
          treated as used from the moment of purchase. Each Uptal Service is a
          digital service that is delivered in full, performed in full, accepted
          in full, and irrevocably consumed at the moment a payment is
          successfully charged, on an initial purchase and on every renewal
          alike, and availability of the Service, and not your use of it, is the
          measure of that performance. No refund is issued for any Uptal
          Service, on any ground and at any time, and no reversal, credit,
          voucher, coupon, discount, account balance, extension of term, free
          period, set-off, deduction, withholding, compensation, damages in
          lieu, or goodwill gesture is issued in place of one. The Refund Policy
          provides for the correction of two billing events that are not
          payments for any Service at all, namely a duplicate charge, however
          the duplication arose, including where it arose from an error in
          Uptal's billing systems, from a repeated submission at checkout, or
          from a repeated capture by a payment provider, and a charge confirmed,
          following Uptal's investigation, to have been made without the
          authority of the payer of record; those corrections are expressly not
          refunds, are not exceptions to this Section, and are made only on the
          conditions set out in Section 10 of the Refund Policy. An amount
          returned under Section 4.16, Section 9.7, or Section 15.11 of the
          Refund Policy is likewise not a refund of any Uptal Service, is not an
          exception to this Section, and is returned only on the conditions set
          out in the Section concerned. Nothing in these Terms or in the Refund
          Policy limits or excludes any right or remedy conferred on you by a
          provision of the law of the Kingdom of Saudi Arabia that is mandatory
          and cannot be waived, limited, or varied by agreement.
        </div>
        <h3 class="sub">6.3 Pricing, VAT &amp; price changes</h3>
        <p>
          All prices are exclusive of Value Added Tax (VAT). Applicable VAT
          (currently 15%) is added at checkout, and a VAT-compliant tax invoice
          is issued for each charge. Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات) may modify pricing at any time without prior notice. The
          price in effect for a new purchase is the price displayed to you at
          checkout for that purchase. The authority you give for a subscription
          is an authority to charge a specific stated amount at a specific
          stated interval, both of which are displayed to you at checkout,
          accepted by you before payment, recorded in the confirmation of your
          purchase, and shown in your Uptal account. Each renewal charge is made
          in that same authorised amount, at that same authorised interval. A
          change to the price of a plan applies to the renewals of a
          subscription you already hold only from the point at which the new
          price has been displayed to you as the amount that will apply to your
          future renewals and has been accepted by you by a separate affirmative
          act, which together form a refreshed authorisation, as occurs on an
          upgrade, a downgrade, a plan change, a change of billing frequency, an
          addition or removal of a seat, a reactivation, a resumption after a
          pause, or a re-entry or replacement of your payment details where the
          new amount is displayed and separately accepted at that time. Until a
          refreshed authorisation is given, each renewal charge for that
          subscription is made in the amount last authorised by you for that
          plan. The automatic updating, re-issue, or replacement of card
          credentials, whether by you, by your card issuer, or by an account
          updater service operated by a card scheme or payment provider, is not
          a refreshed authorisation and does not change the amount you have
          authorised. Section 13.2 of the Refund Policy governs this Section.
        </p>
        <h3 class="sub">6.4 Free trials</h3>
        <p>
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) may offer free trials or
          free features at its discretion. Free trials convert to paid
          subscriptions only where clearly disclosed before you provide payment
          details. Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) may modify or
          withdraw free offerings at any time.
        </p>
        <h3 class="sub">6.5 Chargebacks</h3>
        <p>
          If you have a billing concern, question, or dispute, including a
          charge you do not recognise on your statement or in your banking
          application, you should first submit a ticket at
          <a routerLink="/contact-us">https://uptal.com/contact-us</a>,
          selecting the "Billing &amp; payments" reason, before contacting your
          bank, card issuer, payment provider, card scheme, installment or
          wallet provider, or mobile application store, and you should allow
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) an opportunity to review
          and respond, being five (5) Business Days from the date the ticket is
          received. Where Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) has not
          responded substantively within those five (5) Business Days, this
          Section does not prevent you from contacting your bank, card issuer,
          or payment provider. If a chargeback, payment dispute, or reversal
          request is filed in respect of a charge that is valid under the Refund
          Policy and these Terms, we may suspend or restrict access to the
          affected Service while we investigate and, where the disputed charge
          is found valid, we may recover from you, as a debt due on demand, the
          amount owed together with the reasonable and documented
          administrative, investigation, collection, and legal costs and
          expenses actually incurred by Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات) in recovering that amount, and the amount owed is not
          extinguished by the filing or the outcome of the dispute. Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) does not recover from you, and does
          not levy on you, any chargeback fee, dispute fee, representment fee,
          arbitration fee, fine, or penalty levied on Uptal (شركة الخبرات
          الصاعدة لتقنية المعلومات) by any payment provider, acquiring bank, or
          card scheme, and does not levy any charge for the making of a dispute
          itself. This Section does not apply to, and does not delay, a report
          of fraud or of a lost or stolen payment instrument, a notification to
          your payment service provider of an unauthorised payment transaction,
          a request made to a payment service provider under the Implementing
          Regulations of the Saudi Payments and Payment Services Law, or a
          complaint to any competent authority in the Kingdom of Saudi Arabia.
          Chargebacks and payment disputes are governed in full by Section 11 of
          the Refund Policy, and "Business Day" has the meaning given in the
          Refund Policy.
        </p>
      </section>
      <section id="jobseekers">
        <h2>
          <span class="num">7</span> Job seeker services: Auto-Apply &amp; CV
          Enhancer
        </h2>
        <h3 class="sub">
          7.1 Your authorization to Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات); scope of mandate
        </h3>
        <p>
          By subscribing to, activating, or otherwise enabling Auto-Apply, and
          in particular by selecting, enabling, or operating Auto-Apply in its
          automated "Autopilot" mode, you expressly and unconditionally
          authorize Uptal (شركة الخبرات الصاعدة لتقنية المعلومات), acting
          through its AI Systems and its personnel, to take each of the
          following actions on your behalf and in your name, in each case
          according to, and within the scope determined by, the preferences,
          filters, and targeting parameters you configure in your account from
          time to time: (a) to identify, evaluate, and select job openings,
          vacancies, and other opportunities that the AI Systems assess as
          matching your profile, CV, and stated preferences; (b) to generate,
          adapt, reformat, and tailor versions of your CV, cover materials, and
          application details for specific roles; (c) to complete, populate, and
          submit Applications, including your tailored CV, your application
          details, and the personal data contained in them, to employers,
          applicant tracking systems, and job platforms; (d) to effect
          Submissions to recipients located inside or outside the Kingdom of
          Saudi Arabia where your preferences target such roles; and (e) to take
          such ancillary and incidental steps as are reasonably necessary or
          desirable to give effect to the foregoing. You may adjust your
          targeting preferences, pause, or cancel Auto-Apply at any time from
          your account, with effect on future Submissions only. The grant of
          this authorization is a mandatory condition of using Auto-Apply in
          Autopilot mode: Autopilot cannot be selected, enabled, or operated
          without it; your selection or enabling of Autopilot constitutes your
          express grant of this authorization; and if you do not agree to grant
          it, you must not select, enable, or operate Autopilot.
        </p>
        <p>
          You acknowledge and agree that Auto-Apply operates automatically,
          continuously, and without individual review, approval, or confirmation
          by you of each Application prior to its Submission, and that
          Auto-Apply may accordingly submit Applications to positions,
          employers, or entities that you have not individually reviewed, would
          not have selected manually, or do not want. The scope, volume, timing,
          and destination of Submissions are determined by your profile, your
          CV, and your preference settings as they exist at the time of each
          Submission, and you are solely and exclusively responsible for
          ensuring that they are, and at all times remain, accurate, complete,
          and current. Neither the pausing nor the cancellation of Auto-Apply
          shall have any effect whatsoever on any Application submitted prior to
          the effective time of such pause or cancellation.
        </p>
        <h3 class="sub">7.2 AI-generated output and accuracy; no reliance</h3>
        <div class="callout">
          Uptal's AI Systems are probabilistic and can make mistakes. The AI
          Systems operate by statistical and machine-learning methods that are
          inherently non-deterministic; identical or similar inputs may yield
          different Outputs, and Outputs are generated without human review of
          each individual result. All Outputs, including job matches, match
          scores, rankings, evaluations, and tailored CVs, are estimates and
          approximations only, are provided for general informational purposes,
          and may contain errors, omissions, mischaracterizations, or results
          that are inaccurate, incomplete, outdated, or otherwise unsuitable.
          Matching is never guaranteed to be accurate, exhaustive, or optimal; a
          high match score does not mean that a position is suitable for you,
          that you are suitable for it, that you satisfy the requirements of the
          position, or that the position exists, remains open, or is accurately
          described by the relevant employer or platform. No Output constitutes
          career, professional, legal, or other advice, and no Output should be
          relied upon as such. You are responsible for reviewing and verifying,
          to the extent you consider appropriate, the Outputs and settings that
          drive the operation of the Services. Uptal (شركة الخبرات الصاعدة
          لتقنية المعلومات) makes no representation, warranty, or undertaking of
          any kind, express or implied, that any Output is or will be accurate,
          complete, current, reliable, error-free, or fit for any particular
          purpose, and, to the maximum extent permitted by Applicable Law,
          disclaims all liability arising from or in connection with any
          reliance placed on any Output.
        </div>
        <h3 class="sub">
          7.3 Finality and irrevocability of submitted Applications
        </h3>
        <div class="callout">
          Once an Application has been submitted, it is final and irrevocable,
          and it cannot be retracted, recalled, amended, edited, or deleted by
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات). Upon Submission, an
          Application leaves Uptal's systems and passes into the possession and
          control of third-party employers, applicant tracking systems, and
          platforms over which Uptal (شركة الخبرات الصاعدة لتقنية المعلومات)
          exercises no control and in respect of which Uptal (شركة الخبرات
          الصاعدة لتقنية المعلومات) has no right, ability, or obligation of
          retrieval, rectification, or deletion. Any request to withdraw, amend,
          or correct a submitted Application must be made by you directly to the
          receiving employer or platform, in accordance with that recipient's
          own procedures, and Uptal (شركة الخبرات الصاعدة لتقنية المعلومات)
          shall have no obligation to procure, and gives no assurance as to, the
          success of any such request. No refunds, credits, or compensation of
          any kind will be issued in connection with any submitted Application,
          including any Application submitted to a position, employer, or entity
          that you did not want, would not have selected manually, or had not
          individually reviewed, and you irrevocably waive, release, and
          discharge, to the maximum extent permitted by Applicable Law, any
          claim against Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) arising
          out of or in connection with any Submission effected in accordance
          with the authorization set out in Section 7.1.
        </div>
        <h3 class="sub">
          7.4 Your representations, warranties and undertakings
        </h3>
        <p>
          You represent, warrant, and undertake, on a continuing basis, that:
          (a) all information contained in your CV, profile, and account is and
          will remain truthful, accurate, complete, and up to date, and you
          acknowledge that tailored CVs and other Outputs are generated from,
          and in reliance upon, the information you provide, for the accuracy of
          which you are solely responsible; (b) you hold, and will maintain, all
          rights, permits, and entitlements necessary to seek and take up
          employment in each location that you target; (c) you will review your
          account, your Application history, and your preference settings
          regularly and will keep your preferences current; (d) you will not use
          Auto-Apply or CV Enhancer to submit or procure the submission of any
          false, misleading, or fraudulent information; and (e) you will comply
          with all Applicable Law in connection with your use of the Services
          and any employment you obtain through them.
        </p>
        <h3 class="sub">7.5 No guarantee of outcomes</h3>
        <div class="callout">
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) does not guarantee
          interviews, offers, or employment. Auto-Apply effects Submissions and
          CV Enhancer improves the presentation of your CV; all screening,
          shortlisting, interviewing, and hiring decisions are made solely by
          employers, in their sole discretion, and are outside Uptal's knowledge
          and control. The number of roles matched, the number of Applications
          tailored or submitted, response rates, interview rates, and employment
          outcomes vary, depend on factors outside Uptal's control, and are not
          guaranteed, and no statement on the Website or within the Services
          shall be construed as a guarantee, warranty, or assurance of any
          particular volume, rate, or outcome.
        </div>
        <h3 class="sub">
          7.6 CV uploads, match previews and inclusion in the Uptal talent pool
        </h3>
        <p>
          By uploading, submitting, or synchronizing your CV, profile, or
          related information to Uptal (شركة الخبرات الصاعدة لتقنية المعلومات)
          through any part of the Services, including through the Auto-Apply
          website for the purpose of previewing or checking the number or nature
          of the job matches available to you, and whether or not you
          subsequently subscribe to or purchase any paid Service, you
          acknowledge and agree that Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات) will process and store that information, and that Uptal
          (شركة الخبرات الصاعدة لتقنية المعلومات) may include your profile, CV,
          and related data in its candidate database and talent pool and may
          make them, in whole or in part, available, discoverable, or otherwise
          offered to employers, recruiters, and other Subscribers searching for
          candidates with your skills, experience, or attributes, through Talent
          Search and other current or future Uptal services. Such availability
          and disclosure are carried out in accordance with, and subject to the
          limits described in, the
          <a routerLink="/privacy-policy">Privacy Policy</a>, including the
          provisions governing which data is visible to Subscribers and which
          data is disclosed only upon profile unlock. You represent that the
          information you upload is accurate and that you are entitled to
          provide it, and you may exercise the rights available to you under the
          Privacy Policy and Applicable Law, including requesting the removal of
          your profile from the talent pool, at any time.
        </p>
        <h3 class="sub">7.7 CV Enhancer deliverables; sole remedy</h3>
        <p>
          CV Enhancer produces a personalized digital deliverable prepared on
          the basis of, and in reliance upon, the information you provide. You
          acknowledge that the assessment of the style, presentation, and
          persuasiveness of a CV is inherently subjective. If you are not
          satisfied with a CV Enhancer deliverable, your sole and exclusive
          remedy, and Uptal's entire liability, shall be the provision of
          revisions in accordance with the scope of the service you purchased,
          and not any refund, credit, or other compensation, as further set out
          in Section 9.3 of the Refund Policy. No score improvement guarantee,
          satisfaction guarantee, money back guarantee, or risk free period is
          offered in respect of CV Enhancer or any other Uptal Service. An order
          placed before September 7, 2026 remains governed by the version of the
          Refund Policy published at the time of that order, in accordance with
          Section 9.7 of the Refund Policy.
        </p>
      </section>
      <section id="acceptable-use">
        <h2>
          <span class="num">8</span> Acceptable use &amp; prohibited activities
        </h2>
        <h3 class="sub">8.1 General prohibitions</h3>
        <p>You agree not to use the Services:</p>
        <ul>
          <li>
            In any way that violates any applicable Saudi Arabian or
            international law or regulation.
          </li>
          <li>
            To engage in conduct that restricts or inhibits anyone's use or
            enjoyment of the Services, or that may harm, or create liability
            for, Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) or any user of
            the Services.
          </li>
          <li>
            In any manner that could disable, overburden, damage, or impair the
            Services or interfere with any other party's use of the Services.
          </li>
          <li>
            To submit false, misleading, or fraudulent information, including in
            CVs, profiles, or job applications.
          </li>
        </ul>
        <h3 class="sub">8.2 Prohibited technical activities</h3>
        <p>
          You agree not to engage in any activity that compromises, interferes
          with, or attempts to circumvent the intended use, security, or
          operation of the Services. Prohibited activities include, but are not
          limited to:
        </p>
        <ul>
          <li>
            <b>Unauthorized API access</b>: accessing or attempting to access
            the Services or any API using tools such as Postman, cURL, scripts,
            custom clients, browser extensions, or any other method not
            expressly authorized by Uptal (شركة الخبرات الصاعدة لتقنية
            المعلومات).
          </li>
          <li>
            <b>Scraping and data harvesting</b>: downloading, extracting,
            exporting, mining, indexing, or otherwise collecting data from the
            Services manually or through automated means, including bots,
            crawlers, or spiders.
          </li>
          <li>
            <b>Reverse engineering</b>: attempting to decompile, disassemble,
            reverse engineer, or otherwise derive the source code, architecture,
            models, scoring logic, or algorithms used by Uptal (شركة الخبرات
            الصاعدة لتقنية المعلومات), including its AI or evaluation
            mechanisms.
          </li>
          <li>
            <b>Bypassing security or limits</b>: circumventing, disabling, or
            interfering with authentication, authorization, rate limits, usage
            quotas, monitoring, or any security or technical protection
            measures.
          </li>
          <li>
            <b>Unauthorized security testing</b>: performing penetration
            testing, vulnerability scanning, load testing, or similar testing
            without prior written approval from Uptal (شركة الخبرات الصاعدة
            لتقنية المعلومات).
          </li>
        </ul>
        <p>
          Any such activity constitutes a material breach of these Terms and may
          also constitute a violation of the Saudi Anti-Cyber Crime Law and
          applicable data protection and intellectual property laws. Without
          prejudice to any other right or remedy available to it, Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) may investigate any suspected
          violation of this Section, may suspend or terminate access pursuant to
          Section 14 pending or following any such investigation, may preserve
          and disclose relevant information to competent authorities to the
          extent permitted or required by Applicable Law, and shall be entitled
          to seek injunctive and other equitable relief, in addition to damages,
          in respect of any actual or threatened violation, it being
          acknowledged that damages alone may not be an adequate remedy.
        </p>
      </section>
      <section id="ip">
        <h2><span class="num">9</span> Intellectual property &amp; licenses</h2>
        <h3 class="sub">9.1 Uptal property</h3>
        <p>
          All content and materials provided on or through the Services,
          including text, graphics, logos, icons, images, audio and video clips,
          data compilations, software, algorithms, and user interface designs,
          are the property of Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) or
          its licensors and are protected by Saudi Arabian and international
          copyright and intellectual property laws.
        </p>
        <h3 class="sub">9.2 Your license to use the Services</h3>
        <p>
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) grants you a limited,
          non-exclusive, non-transferable, revocable license to access and use
          the Services for your internal business purposes (Subscribers) or your
          personal, non-commercial job search (Job Seekers). This license does
          not include any right to reproduce, modify, distribute, publicly
          display, or create derivative works from our content except as
          expressly permitted in writing by Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات).
        </p>
        <h3 class="sub">9.3 Your content</h3>
        <p>
          You retain ownership of the content you submit to the Services,
          including your CV. By submitting content, you grant Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) a worldwide, non-exclusive,
          royalty-free license to host, store, process, adapt, and transmit that
          content as needed to provide the Services, including generating
          tailored versions of your CV and submitting them to employers on your
          instructions (Auto-Apply), and producing your enhanced CV (CV
          Enhancer). This license survives termination of these Terms solely to
          the extent necessary for Uptal (شركة الخبرات الصاعدة لتقنية المعلومات)
          to comply with Applicable Law, to maintain business records, and to
          enforce or defend its rights.
        </p>
        <h3 class="sub">9.4 Feedback</h3>
        <p>
          If you provide Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) with any
          suggestions, ideas, enhancement requests, recommendations, or other
          feedback relating to the Services ("Feedback"), you grant Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) a perpetual, irrevocable, worldwide,
          royalty-free, fully paid-up, sublicensable, and transferable license
          to use, reproduce, modify, adapt, publish, and otherwise exploit such
          Feedback for any purpose, without restriction, attribution, or
          compensation, and you waive, to the maximum extent permitted by
          Applicable Law, any moral or similar rights in such Feedback.
        </p>
      </section>
      <section id="privacy">
        <h2><span class="num">10</span> Privacy &amp; PDPL compliance</h2>
        <p>
          Your use of the Services is also governed by our
          <a routerLink="/privacy-policy">Privacy Policy</a>, which explains how
          we collect, use, and disclose personal data. By using the Services,
          you acknowledge that your personal data will be processed as described
          in the Privacy Policy, on the legal bases set out there, in compliance
          with the Saudi Personal Data Protection Law (PDPL) and its
          Implementing Regulations.
        </p>
      </section>
      <section id="custodianship">
        <h2>
          <span class="num">11</span> Data custodianship &amp; platform outputs
        </h2>
        <div class="note">
          Important: under the PDPL, personal data is subject to data subject
          rights and lawful processing obligations. These Terms clarify rights
          and responsibilities; they do not transfer ownership of personal data.
        </div>
        <h3 class="sub">11.1 Candidate data and custodianship</h3>
        <ul>
          <li>
            Personal data relating to Candidates is not owned by Customers, and
            Customers do not acquire any ownership, property, or proprietary
            rights in Candidate personal data by virtue of using the Services.
          </li>
          <li>
            Candidates retain their rights as data subjects under applicable
            data protection laws.
          </li>
          <li>
            Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) acts as a lawful
            custodian of Candidate personal data and processes such data
            strictly in accordance with applicable law, our Privacy Policy, and
            documented service purposes.
          </li>
          <li>
            Nothing in these Terms shall be interpreted as transferring
            ownership of personal data to any party.
          </li>
        </ul>
        <h3 class="sub">11.2 Platform outputs and derived data</h3>
        <p>
          Unless explicitly stated otherwise in a written agreement, Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) retains all rights, title, and
          interest in platform-generated outputs and derived data, including
          AI-generated assessments, scores, evaluations, reports, structured
          insights, tailored-CV formatting and structure, usage data, system
          logs, aggregated and anonymized data, and improvements derived from
          platform usage. Such derived data may be used to operate, secure, and
          improve the Services.
        </p>
        <h3 class="sub">11.3 License to access data</h3>
        <p>
          Customers are granted a limited, non-exclusive, non-transferable,
          revocable license to access data and outputs solely through the
          Services and strictly for internal business purposes. No right is
          granted to export, resell, sublicense, scrape, or reuse data outside
          the Services unless expressly authorized in writing by Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات).
        </p>
      </section>
      <section id="analytics">
        <h2><span class="num">12</span> Usage data &amp; analytics</h2>
        <p>
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) may collect and process
          technical and usage data to operate, secure, troubleshoot, analyze,
          and improve the platform. This may include traffic and usage
          analytics, session recordings and interaction data, and device,
          browser, IP, and performance metrics. Such data is processed in
          accordance with the PDPL and our Privacy Policy.
        </p>
      </section>
      <section id="thirdparty">
        <h2><span class="num">13</span> Third-party services</h2>
        <p>
          The Services may rely on or link to third-party services, including
          payment processors, cloud hosting providers, and employer or
          job-platform systems to which applications are submitted. Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) does not control, endorse, or assume
          any responsibility or liability for the content, availability,
          policies, or practices of any third-party service, including the
          existence, accuracy, or currency of job postings, employer screening
          and verification practices, hiring decisions, or the handling of
          personal data by such third parties, and your access to and dealings
          with any third-party service are solely at your own risk and subject
          to that third party's own terms and policies, which you are
          responsible for reviewing. Payment card data is processed by our
          third-party payment processor and is not stored on Uptal servers.
        </p>
      </section>
      <section id="termination">
        <h2><span class="num">14</span> Suspension &amp; termination</h2>
        <p>
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) may suspend, restrict,
          disable, or terminate your access to the Services, in whole or in
          part, at any time, with or without notice, and without liability to
          you, if: (i) you breach these Terms, or Uptal (شركة الخبرات الصاعدة
          لتقنية المعلومات) has reasonable grounds, recorded at the time, for
          concluding that you have breached them, in which case Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) may suspend access pending
          investigation, and where that suspension is lifted because no breach
          is established your access is restored and extended as set out at the
          end of this Section; (ii) your use of the Services poses, in Uptal's
          reasonable assessment, a security, legal, regulatory, reputational, or
          operational risk to Uptal (شركة الخبرات الصاعدة لتقنية المعلومات), the
          Services, or any third party; (iii) suspension or termination is
          required by Applicable Law or by any competent authority; or (iv)
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) elects to discontinue
          the Services or any part of them. You may terminate your account at
          any time in accordance with Section 6.
        </p>
        <p>
          Upon any termination: (a) all rights and licenses granted to you under
          these Terms shall immediately cease; (b) you shall immediately cease
          all access to and use of the Services; (c) Uptal (شركة الخبرات الصاعدة
          لتقنية المعلومات) may, subject to the Privacy Policy and Applicable
          Law, deactivate, archive, or delete your account and associated data;
          and (d) any provision of these Terms that by its nature or express
          terms should survive termination, including Sections 2, 7.2, 7.3, 9,
          11, 15, 16, 17, 19 through 25, shall so survive. Where Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) suspends, restricts, disables, or
          terminates your account or your access under this Section, no further
          renewal charge is made while that suspension or termination continues,
          and the subscription is treated as ceasing for billing purposes with
          effect from the end of the billing period then current. Where the
          suspension or termination begins during a billing period for which you
          have already been charged, the service for that billing period was
          made available to you at the moment of that charge, that charge
          remains fully earned and final, no part of it is repaid, credited,
          apportioned, or extended, and all unused allowances expire, and that
          applies whatever the ground of the suspension or termination, save
          only where the following sentence applies. Where a suspension imposed
          pending investigation is lifted because no breach is established,
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) restores your access and
          extends the billing period concerned by the length of the suspension;
          that extension is a re-performance of the service you purchased and is
          not a refund, a credit, or a correction. Where Uptal (شركة الخبرات
          الصاعدة لتقنية المعلومات) exercises the right in paragraph (iv) above
          and permanently discontinues a paid Service during a billing period
          for which you have been charged, Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات) continues to make that Service, or a substitute or
          successor Uptal Service selected by Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات), available to you for the remainder of that billing period,
          so that you receive the whole of the billing period you purchased, and
          ceases to charge for that Service with effect from the end of that
          period. Save as set out above in this Section, termination shall not
          entitle you to any refund, credit, or compensation, except where and
          to the extent required by mandatory Applicable Law, and shall be
          without prejudice to any rights, remedies, obligations, or liabilities
          accrued prior to the date of termination. Sections 5.6 and 14.3 of the
          Refund Policy govern suspension, termination, and discontinuation for
          billing purposes.
        </p>
      </section>
      <section id="disclaimers">
        <h2><span class="num">15</span> Disclaimer of warranties</h2>
        <p class="caps">
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICES, THE
          WEBSITE, AND ALL OUTPUTS ARE PROVIDED ON AN "AS IS", "AS AVAILABLE",
          AND "WITH ALL FAULTS" BASIS, WITHOUT WARRANTIES, CONDITIONS,
          REPRESENTATIONS, OR UNDERTAKINGS OF ANY KIND, WHETHER EXPRESS,
          IMPLIED, STATUTORY, OR OTHERWISE. WITHOUT LIMITING THE GENERALITY OF
          THE FOREGOING, UPTAL (شركة الخبرات الصاعدة لتقنية المعلومات) AND ITS
          LICENSORS AND SUPPLIERS EXPRESSLY DISCLAIM ANY AND ALL IMPLIED
          WARRANTIES OF MERCHANTABILITY, SATISFACTORY QUALITY, FITNESS FOR A
          PARTICULAR PURPOSE, ACCURACY, COMPLETENESS, TITLE, QUIET ENJOYMENT,
          AND NON-INFRINGEMENT, AND ANY WARRANTIES ARISING OUT OF COURSE OF
          DEALING, COURSE OF PERFORMANCE, OR USAGE OF TRADE.
        </p>
        <p>
          Without limiting the foregoing, Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات) does not warrant, represent, or undertake that: (a) the
          Services will be uninterrupted, timely, secure, error-free, or free of
          viruses or other harmful components, or that defects will be
          corrected; (b) candidate data, job matches, tailored CVs, or any other
          Output will be accurate, complete, current, or reliable; (c) any job
          posting accessible through or targeted by the Services exists, remains
          open, or is accurately described; or (d) use of the Services will
          result in hires (for Subscribers) or in interviews, offers, or
          employment (for Job Seekers). No advice or information, whether oral
          or written, obtained by you from Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات) or through the Services shall create any warranty not
          expressly stated in these Terms.
        </p>
      </section>
      <section id="liability">
        <h2>
          <span class="num">16</span> Limitation and exclusion of liability
        </h2>
        <p>
          To the maximum extent permitted by Applicable Law, in no event shall
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) or its officers,
          directors, employees, agents, licensors, or suppliers be liable,
          whether in contract, tort (including negligence), breach of statutory
          duty, or otherwise, for: (a) any indirect, incidental, special,
          consequential, exemplary, or punitive damages; (b) any loss of
          profits, revenues, or anticipated savings; (c) any loss of employment,
          employment opportunities, or earning capacity; (d) any loss of, damage
          to, or corruption of data; (e) any loss of use, goodwill, or
          reputation, or any other intangible loss; or (f) any loss or damage
          arising out of or in connection with any Output, any matching result,
          any Application or Submission (including any Application submitted
          through Auto-Apply to a position, employer, or entity that you did not
          want, would not have selected manually, or had not individually
          reviewed), any act or omission of any employer, platform, or other
          third party, or any reliance placed by you on any Output, in each case
          arising out of or in connection with these Terms, the Services, or the
          Website, even if Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) has
          been advised of the possibility of such loss or damage.
        </p>
        <p>
          Without limiting the foregoing, and to the maximum extent permitted by
          Applicable Law, Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) shall
          have no liability whatsoever for: (a) any content, information, or
          material submitted by you or by any other user, including its
          accuracy, legality, or completeness; (b) the acts, omissions,
          decisions, or conduct of any employer, Candidate, Subscriber, Job
          Seeker, platform, or other third party, including screening,
          interviewing, and hiring decisions and the handling of any
          Application; (c) any loss, corruption, or deletion of data, it being
          your sole responsibility to maintain independent copies of any content
          you submit to the Services; (d) any unauthorized access to or use of
          your account resulting in whole or in part from your acts or
          omissions; (e) any suspension, modification, discontinuance, or
          unavailability of the Services or any part of them; and (f) any event
          or circumstance described in Section 18 (Force majeure).
        </p>
        <p>
          To the extent permitted by Applicable Law, the total aggregate
          liability of Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) and the
          Uptal Indemnified Parties (as defined in Section 17), taken together,
          arising out of or relating to these Terms, the Services, or the
          Website, howsoever arising and under whatever theory of liability,
          shall not in any circumstances exceed the aggregate of the amounts
          paid by you to Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) in the
          twelve (12) months preceding the date on which the claim was first
          raised with Uptal (شركة الخبرات الصاعدة لتقنية المعلومات). The
          existence of more than one claim shall not enlarge this limit, and
          where a single set of circumstances affects more than one charge the
          claims are subject to that single aggregate limit. In respect of any
          claim relating to a charge, the limit stated in Section 5.9 of the
          Refund Policy applies in place of any lower limit stated in this
          Section, in accordance with Section 1.8 of that Policy. This Section
          does not limit, and does not apply to, the correction of a charge
          under Section 10 of the Refund Policy, which is not a payment of
          damages, or any liability to return an amount received without lawful
          cause.
        </p>
        <p>
          Your sole and exclusive remedy for any dissatisfaction with the
          Services, with any Output, or with these Terms is to discontinue your
          use of the Services and, where applicable, to cancel in accordance
          with these Terms. You acknowledge and agree that the disclaimers,
          exclusions, and limitations set out in these Terms represent a fair
          and reasonable allocation of risk between you and Uptal (شركة الخبرات
          الصاعدة لتقنية المعلومات) in light of the nature and price of the
          Services, form an essential basis of the bargain between the parties,
          and shall apply notwithstanding the failure of the essential purpose
          of any limited remedy.
        </p>
        <p>
          To the extent permitted by Applicable Law, any claim or cause of
          action you may have arising out of or relating to these Terms, the
          Services, or the Website must be commenced within twelve (12) months
          after the date on which the cause of action first arose, failing which
          such claim or cause of action is permanently barred and waived.
          Nothing in these Terms excludes or limits any liability that cannot be
          excluded or limited under applicable Saudi law, including liability
          arising from fraud or willful misconduct, and these Terms shall be
          construed accordingly.
        </p>
      </section>
      <section id="indemnification">
        <h2><span class="num">17</span> Indemnification</h2>
        <p>
          You agree to indemnify, defend, and hold harmless Uptal (شركة الخبرات
          الصاعدة لتقنية المعلومات), its officers, directors, employees, agents,
          licensors, and suppliers (the "Uptal Indemnified Parties") from and
          against any and all claims, demands, actions, proceedings,
          liabilities, damages, losses, costs, and expenses (including
          reasonable attorneys' fees and costs of investigation) arising out of
          or in any way connected with: (a) your access to or use of the
          Services or Website; (b) your breach or alleged breach of these Terms
          or of any Applicable Law; (c) any content, data, or information you
          submit to or through the Services, including any inaccurate,
          incomplete, misleading, or unlawful CV, profile, or application
          information; (d) any Application submitted on your behalf in
          accordance with your authorization under Section 7.1; or (e) your
          violation of any right of any other person or entity. Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) reserves the right, at your expense,
          to assume the exclusive defense and control of any matter otherwise
          subject to indemnification by you, in which event you agree to
          cooperate fully with Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) in
          asserting any available defenses, and you shall not settle any such
          matter without Uptal's prior written consent.
        </p>
      </section>
      <section id="force-majeure">
        <h2><span class="num">18</span> Force majeure</h2>
        <p>
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) shall not be in breach
          of these Terms, nor liable for any failure or delay in the performance
          of any of its obligations under these Terms, to the extent that such
          failure or delay arises from or is attributable to any act, event,
          omission, or circumstance beyond Uptal's reasonable control (each, a
          "Force Majeure Event"), including acts of God, flood, drought,
          earthquake, or other natural disaster; epidemic or pandemic; terrorist
          attack, civil war, civil commotion, or riot; war or armed conflict;
          the imposition of sanctions, embargo, or breaking-off of diplomatic
          relations; any law or any action taken by a government or public
          authority; the collapse of buildings, fire, explosion, or accident;
          any labor or trade dispute, strike, industrial action, or lockout; the
          interruption, degradation, or failure of utility services,
          telecommunications networks, hosting infrastructure, or third-party
          services; and any denial-of-service or other malicious attack. During
          the continuance of a Force Majeure Event, Uptal's affected obligations
          shall be suspended, and Uptal (شركة الخبرات الصاعدة لتقنية المعلومات)
          shall use commercially reasonable endeavors to mitigate the effects of
          the Force Majeure Event.
        </p>
      </section>
      <section id="severability">
        <h2><span class="num">19</span> Severability; no waiver</h2>
        <p>
          If any provision or part-provision of these Terms is or becomes
          invalid, illegal, or unenforceable in any jurisdiction, it shall, to
          the extent required, be deemed modified to the minimum extent
          necessary to make it valid, legal, and enforceable, and, if such
          modification is not possible, the relevant provision or part-provision
          shall be deemed deleted; any such modification or deemed deletion
          shall not affect the validity, legality, or enforceability of the
          remaining provisions of these Terms, which shall continue in full
          force and effect. No failure or delay by Uptal (شركة الخبرات الصاعدة
          لتقنية المعلومات) in exercising any right, power, or remedy under
          these Terms or at law shall operate as a waiver of that or any other
          right, power, or remedy, and no single or partial exercise of any
          right, power, or remedy shall preclude any further exercise of it or
          the exercise of any other right, power, or remedy. A waiver shall be
          effective only if given expressly and in writing.
        </p>
      </section>
      <section id="assignment">
        <h2><span class="num">20</span> Assignment</h2>
        <p>
          You may not assign, transfer, sub-license, charge, subcontract,
          delegate, or otherwise deal in any manner with any or all of your
          rights or obligations under these Terms without the prior written
          consent of Uptal (شركة الخبرات الصاعدة لتقنية المعلومات), and any
          purported assignment or transfer in violation of this Section shall be
          null and void. Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) may at
          any time assign, transfer, charge, subcontract, delegate, or otherwise
          deal with any or all of its rights and obligations under these Terms,
          including in connection with any merger, acquisition, corporate
          reorganization, or sale of all or substantially all of its assets,
          without your consent and without notice to you. These Terms shall be
          binding upon and inure to the benefit of the parties and their
          respective successors and permitted assigns.
        </p>
      </section>
      <section id="notices">
        <h2>
          <span class="num">21</span> Notices and electronic communications
        </h2>
        <p>
          You consent to receive communications from Uptal (شركة الخبرات الصاعدة
          لتقنية المعلومات) electronically, including by email to the address
          associated with your account, by messages, banners, or notifications
          within the Services, or by posting on the Website, and you agree that
          all agreements, notices, disclosures, and other communications that
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) provides to you
          electronically satisfy any legal requirement that such communications
          be in writing. Notices to Uptal (شركة الخبرات الصاعدة لتقنية
          المعلومات) shall be given in writing by submitting a ticket at
          <a routerLink="/contact-us">https://uptal.com/contact-us</a>,
          selecting the "Billing &amp; payments" reason where the matter
          concerns a charge, and shall be deemed received on the date the ticket
          is received by the Uptal ticketing system, of which date Uptal's
          ticket records are evidence. Email to any address, social media
          messages, messaging applications, in-product chat, telephone calls,
          and messages to individual employees, officers, agents, contractors,
          or representatives do not constitute notice for the purposes of these
          Terms and do not start, pause, extend, or satisfy any period under
          them, save where the Refund Policy expressly provides otherwise, and
          in particular Section 12.6 of that Policy, under which a written
          notice given by another means and in fact received by Uptal (شركة
          الخبرات الصاعدة لتقنية المعلومات) is valid notice where the ticketing
          system was unavailable to you, Section 9.7 of that Policy, under which
          a claim under the former score improvement guarantee sent to the
          retired electronic mail address within the period stated in that
          Section is treated as validly made, and Section 15.11 of that Policy,
          under which notification of the death of a subscriber may be given by
          any means. Submitting a ticket is not a cancellation of a
          subscription; cancellation is performed only in the manner set out in
          Section 6.1. You are responsible for keeping your contact details
          accurate and current, and a notice sent by Uptal (شركة الخبرات الصاعدة
          لتقنية المعلومات) to the most recent email address associated with
          your account shall be deemed validly given whether or not actually
          received or read by you.
        </p>
      </section>
      <section id="language">
        <h2><span class="num">22</span> Language</h2>
        <p>
          These Terms are prepared and published in both the English and Arabic
          languages, and each version is intended to have the same meaning and
          effect. In the event of any conflict, ambiguity, or inconsistency
          between the English and Arabic versions, the Arabic version shall
          prevail to the extent required by Applicable Law, and otherwise the
          versions shall, so far as possible, be read and construed consistently
          with one another.
        </p>
      </section>
      <section id="survival">
        <h2>
          <span class="num">23</span> Survival; entire agreement; no third-party
          rights
        </h2>
        <p>
          The provisions of these Terms that by their nature or express terms
          are intended to survive expiry or termination shall so survive,
          including the provisions identified in Section 14. These Terms,
          together with the documents incorporated by reference in Section 1,
          constitute the entire agreement and understanding between you and
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) with respect to their
          subject matter and the Services, and supersede and extinguish all
          prior and contemporaneous agreements, promises, assurances,
          warranties, representations, proposals, and understandings between the
          parties, whether written or oral, relating to that subject matter;
          provided that nothing in this Section shall limit or exclude any
          liability for fraud. You acknowledge that in entering into these Terms
          you do not rely on any statement, representation, assurance, or
          warranty (whether made innocently or negligently) that is not set out
          in these Terms. Except as expressly provided in these Terms, no person
          other than you and Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) shall
          have any right to enforce any of these Terms.
        </p>
      </section>
      <section id="law">
        <h2><span class="num">24</span> Governing law &amp; jurisdiction</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the
          laws of the Kingdom of Saudi Arabia, without giving effect to any
          principles of conflicts of law. You agree that any action arising out
          of or relating to these Terms or your use of the Services shall be
          filed only in the courts located in Riyadh, Saudi Arabia, and you
          hereby consent and submit to the jurisdiction of such courts.
        </p>
      </section>
      <section id="changes">
        <h2><span class="num">25</span> Changes to these Terms</h2>
        <p>
          Uptal (شركة الخبرات الصاعدة لتقنية المعلومات) reserves the right to
          modify or update these Terms at any time. Updated Terms are posted on
          the Website and take effect immediately upon publication. Your
          continued use of the Services after any changes constitutes your
          acceptance of the updated Terms. If you do not agree to the updated
          Terms, you must stop using the Services. Uptal (شركة الخبرات الصاعدة
          لتقنية المعلومات) shall have no liability to you or to any third party
          for any modification of these Terms or for any modification,
          suspension, or discontinuance of the Services.
        </p>
      </section>
      <section id="contact">
        <h2><span class="num">26</span> Contact</h2>
        <p>
          If you have any questions about these Terms, please contact us by
          submitting a ticket at
          <a routerLink="/contact-us">https://uptal.com/contact-us</a>,
          selecting the "Billing &amp; payments" reason where the matter
          concerns a charge. Last updated September 7, 2026.
        </p>
      </section>
    </article>
  </div>
</div>

<!-- Arabic -->
<div class="legal-page pt-28" dir="rtl" lang="ar" *ngIf="isArabic">
  <div class="hero">
    <span class="eyebrow"
      ><span aria-hidden="true" class="dot"></span> الشروط والأحكام</span
    >
    <h1>الشروط والأحكام</h1>
    <p class="lede">
      تحكم هذه الشروط استخدامك لموقع شركة الخبرات الصاعدة لتقنية المعلومات
      ومنصتها وجميع خدماتها: البحث عن الكفاءات والمقابلات والتقييمات لأصحاب
      العمل، والتقديم التلقائي وتحسين السيرة الذاتية للباحثين عن عمل.
    </p>
    <div class="meta">
      <span><b>آخر تحديث:</b> 7 سبتمبر 2026 </span
      ><span
        ><b>المزوّد:</b> شركة الخبرات الصاعدة لتقنية المعلومات، المملكة العربية
        السعودية</span
      >
    </div>
  </div>
  <div class="wrap">
    <nav aria-label="في هذه الصفحة" class="toc">
      <div class="inner">
        <h4>في هذه الصفحة</h4>
        <ol>
          <li>
            <a [routerLink]="[]" fragment="acceptance">قبول هذه الشروط</a>
          </li>
          <li><a [routerLink]="[]" fragment="definitions">التعريفات</a></li>
          <li><a [routerLink]="[]" fragment="eligibility">الأهلية</a></li>
          <li><a [routerLink]="[]" fragment="services">خدماتنا</a></li>
          <li>
            <a [routerLink]="[]" fragment="accounts">حسابات المستخدمين</a>
          </li>
          <li>
            <a [routerLink]="[]" fragment="payments"
              >المدفوعات والاشتراكات والاسترداد</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="jobseekers"
              >خدمات الباحثين عن عمل: التقديم التلقائي وتحسين السيرة الذاتية</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="acceptable-use"
              >الاستخدام المقبول والأنشطة المحظورة</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="ip">الملكية الفكرية والتراخيص</a>
          </li>
          <li>
            <a [routerLink]="[]" fragment="privacy"
              >الخصوصية وحماية البيانات الشخصية</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="custodianship"
              >حفظ البيانات ومخرجات المنصة</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="analytics"
              >بيانات الاستخدام والتحليلات</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="thirdparty">خدمات الأطراف الثالثة</a>
          </li>
          <li>
            <a [routerLink]="[]" fragment="termination">التعليق والإنهاء</a>
          </li>
          <li>
            <a [routerLink]="[]" fragment="disclaimers"
              >إخلاء المسؤولية عن الضمانات</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="liability"
              >حدود المسؤولية واستبعادها</a
            >
          </li>
          <li><a [routerLink]="[]" fragment="indemnification">التعويض</a></li>
          <li>
            <a [routerLink]="[]" fragment="force-majeure">القوة القاهرة</a>
          </li>
          <li>
            <a [routerLink]="[]" fragment="severability"
              >قابلية الفصل؛ عدم التنازل</a
            >
          </li>
          <li><a [routerLink]="[]" fragment="assignment">التنازل</a></li>
          <li>
            <a [routerLink]="[]" fragment="notices"
              >الإشعارات والمراسلات الإلكترونية</a
            >
          </li>
          <li><a [routerLink]="[]" fragment="language">اللغة</a></li>
          <li>
            <a [routerLink]="[]" fragment="survival">البقاء؛ كامل الاتفاق</a>
          </li>
          <li>
            <a [routerLink]="[]" fragment="law"
              >القانون الحاكم والاختصاص القضائي</a
            >
          </li>
          <li>
            <a [routerLink]="[]" fragment="changes">التغييرات على هذه الشروط</a>
          </li>
          <li><a [routerLink]="[]" fragment="contact">التواصل</a></li>
        </ol>
      </div>
    </nav>
    <article>
      <section id="acceptance">
        <h2><span class="num">1</span> قبول هذه الشروط وأثرها الملزم</h2>
        <p>
          مرحبًا بك في شركة الخبرات الصاعدة لتقنية المعلومات. تشكّل هذه الشروط
          والأحكام (مع جميع الوثائق والسياسات والملاحق المدمجة فيها بالإشارة،
          ويُشار إليها مجتمعةً بـ"الشروط") اتفاقًا قانونيًا ملزمًا بينك وبين
          شركة الخبرات الصاعدة لتقنية المعلومات، وتحكم وصولك إلى موقع شركة
          الخبرات الصاعدة لتقنية المعلومات ومنصتها وتطبيقاتها وواجهاتها وجميع
          الخدمات والميزات والوظائف والمحتوى والأدوات التي تتيحها شركة الخبرات
          الصاعدة لتقنية المعلومات أو مَن ينوب عنها من وقت لآخر (يُشار إليها
          مجتمعةً بـ"الخدمات") واستخدامَك لها. وبوصولك إلى أي جزء من الخدمات أو
          تصفّحه أو التسجيل فيه أو الاشتراك فيه أو تفعيله أو استخدامه بأي شكل
          آخر، أو بالنقر للقبول أو الموافقة على هذه الشروط حيثما يُتاح لك ذلك،
          أو باستمرارك في استخدام الخدمات بعد أي تحديث لهذه الشروط، فإنك تقرّ
          بأنك قرأت هذه الشروط وفهمتها ووافقت على الالتزام بها والتقيّد بها
          كاملةً ودون تعديل. وإذا لم توافق على هذه الشروط، أو لم تكن مؤهلًا أو
          مخوَّلًا بالموافقة عليها، فيجب عليك عدم الوصول إلى الخدمات أو
          استخدامها، والتوقف فورًا عن أي وصول إليها أو استخدام لها.
        </p>
        <p>
          تُدمَج في هذه الشروط بالإشارة، وتُقرأ جنبًا إلى جنب معها،
          <a routerLink="/privacy-policy">سياسة الخصوصية</a> و<a
            routerLink="/refund-policy"
            >سياسة الاسترداد</a
          >
          الخاصتان بنا، بصيغتيهما المعدَّلتين من وقت لآخر، إضافةً إلى أي شروط
          خاصة بمنتج معيّن أو نماذج طلب أو إشعارات تكميلية تُعرَض عليك داخل
          الخدمات. وفي حال وجود أي تعارض أو عدم اتساق بين هذه الشروط وأي وثيقة
          مدمجة بالإشارة، تسود هذه الشروط في حدود ذلك التعارض أو عدم الاتساق،
          على أن تسود سياسة الاسترداد فيما يتعلق بمسائل الفوترة والاسترداد
          ونزاعات الدفع، وتسود سياسة الخصوصية فيما يتعلق بمعالجة البيانات
          الشخصية.
        </p>
        <p>
          وتقرّ وتضمن أن قبولك لهذه الشروط وتنفيذك لالتزاماتك بموجبها لا يخالف،
          ولن يخالف، أي اتفاق آخر أنت طرف فيه، أو أي حكم أو أمر أو قرار ملزم لك،
          أو أي نظام سارٍ.
        </p>
        <div class="note">
          حقوقك النظامية. لا يوجد في هذه الشروط ما يحدّ أو يستثني، أو يُقصَد به
          أن يحدّ أو يستثني، أي حق أو وسيلة انتصاف تكفلها لك أحكام نظام التجارة
          الإلكترونية أو إطار حماية المستهلك أو نظام حماية البيانات الشخصية أو
          أي حكم آخر من أحكام الأنظمة السارية يكون إلزاميًا ولا يجوز التنازل عنه
          أو تقييده أو تعديله بالاتفاق، وتُفسَّر جميع القيود والاستثناءات
          والتفويضات والإقرارات الواردة في هذه الشروط وفقًا لذلك، ولا تسري إلا
          إلى أقصى حد تسمح به الأنظمة السارية.
        </div>
      </section>
      <section id="definitions">
        <h2><span class="num">2</span> التعريفات وقواعد التفسير</h2>
        <h3 class="sub"><span class="n">2.1</span> التعريفات</h3>
        <p>
          في هذه الشروط، وما لم يقتضِ السياق خلاف ذلك، تحمل المصطلحات التالية
          المعاني المبيَّنة قرين كل منها:
        </p>
        <ul>
          <li>
            "شركة الخبرات الصاعدة لتقنية المعلومات" أو "نحن" أو "لنا" تشير إلى
            شركة الخبرات الصاعدة لتقنية المعلومات، المملكة العربية السعودية،
            ويشمل ذلك خلفاءها والمتنازَل لهم المصرَّح لهم.
          </li>
          <li>
            "الخدمات" تعني جميع المنتجات والخدمات التي تقدّمها شركة الخبرات
            الصاعدة لتقنية المعلومات أو مَن ينوب عنها، بما في ذلك الموقع
            الإلكتروني والبحث عن الكفاءات والتقديم التلقائي وتحسين السيرة
            الذاتية والمقابلات والتقييمات وبرمجيات إدارة التوظيف، وجميع ما يرتبط
            بها من ميزات وأدوات وواجهات ومحتوى، بصيغتها المعدَّلة أو المكمَّلة
            أو الموقوفة من وقت لآخر.
          </li>
          <li>
            "الموقع الإلكتروني" يعني الموقع المتاح على
            <a class="en" routerLink="/">https://uptal.com</a> وأي مواقع أو
            نطاقات فرعية أو تطبيقات مرتبطة به تابعة لشركة الخبرات الصاعدة لتقنية
            المعلومات.
          </li>
          <li>
            "أنظمة الذكاء الاصطناعي" تعني أنظمة ونماذج وعمليات الذكاء الاصطناعي
            وتعلّم الآلة والأساليب الإحصائية والخوارزمية وغيرها من الأنظمة
            الآلية التي تستخدمها شركة الخبرات الصاعدة لتقنية المعلومات أو مَن
            ينوب عنها في سياق الخدمات، بما في ذلك الأنظمة المستخدمة في المطابقة
            والترتيب واحتساب الدرجات والتقييم وإنشاء السير الذاتية وتخصيصها
            وإعداد الطلبات وتقديمها.
          </li>
          <li>
            "الطلب" يعني أي طلب توظيف أو إبداء اهتمام أو تقديم مماثل، مع ما
            يشمله من سيرة ذاتية مخصَّصة ومواد مصاحبة وبيانات طلب وبيانات شخصية،
            يُعَدّ و/أو يُقدَّم عبر الخدمات؛ و"التقديم" يعني فعل إرسال الطلب إلى
            أي صاحب عمل أو نظام تتبّع متقدمين أو منصة توظيف أو أي مستلم آخر.
          </li>
          <li>
            "المخرجات" تعني أي محتوى أو نتيجة أو مادة تُولَّد كليًا أو جزئيًا
            بواسطة أنظمة الذكاء الاصطناعي، بما في ذلك مطابقات الوظائف ودرجات
            التوافق والترتيب والتقييمات والرؤى والتوصيات والسير الذاتية
            المخصَّصة أو المحسَّنة.
          </li>
          <li>
            "المشترك" أو "العميل" يعني صاحب عمل أو جهة توظيف أو مسؤول توظيف
            يستخدم الخدمات لأغراض التوظيف.
          </li>
          <li>
            "الباحث عن عمل" يعني أي فرد يستخدم التقديم التلقائي أو تحسين السيرة
            الذاتية أو أي خدمة من خدمات شركة الخبرات الصاعدة لتقنية المعلومات
            الموجّهة للمرشحين.
          </li>
          <li>
            "المرشح" يعني أي فرد يكون ملفه أو سيرته الذاتية أو مقابلته أو تقييمه
            متاحًا عبر الخدمات.
          </li>
          <li>
            "المستخدم" أو "أنت" تشير إلى أي فرد أو كيان يصل إلى الخدمات أو
            الموقع الإلكتروني أو يستخدمهما بأي صفة كانت.
          </li>
          <li>
            "الأنظمة السارية" تعني جميع الأنظمة واللوائح والمراسيم الملكية
            واللوائح التنفيذية والقواعد والأوامر والإرشادات الملزمة الصادرة عن
            أي جهة مختصة والمنطبقة على أي طرف أو على الخدمات، بما فيها أنظمة
            المملكة العربية السعودية، بصيغتها المعدَّلة أو المعاد إصدارها أو
            المستبدَلة من وقت لآخر.
          </li>
          <li>"حدث القوة القاهرة" يحمل المعنى المبيَّن له في القسم 18.</li>
        </ul>
        <h3 class="sub"><span class="n">2.2</span> قواعد التفسير</h3>
        <p>
          في هذه الشروط، وما لم يقتضِ السياق خلاف ذلك: (أ) أُدرِجت العناوين
          الرئيسية والفرعية لتيسير الرجوع إليها فقط، ولا تؤثر في بناء هذه الشروط
          أو تفسيرها؛ (ب) تشمل صيغة المفرد صيغة الجمع والعكس صحيح؛ (ج) تُفسَّر
          عبارات "يشمل" و"بما في ذلك" و"على وجه الخصوص" على أنها للتمثيل لا
          للحصر، ودون تقييد لعموم ما سبقها؛ (د) أي إشارة إلى نظام أو لائحة أو
          حكم نظامي هي إشارة إليه بصيغته المعدَّلة أو الممدَّدة أو المعاد
          إصدارها أو المستبدَلة من وقت لآخر، وتشمل جميع التشريعات الفرعية
          الصادرة بموجبه؛ (هـ) أي إشارة إلى "الكتابة" أو "كتابيًا" تشمل
          المراسلات الإلكترونية؛ (و) حيثما يكون لشركة الخبرات الصاعدة لتقنية
          المعلومات حق التحديد أو الموافقة أو القبول أو التقدير، يجوز لها، إلى
          أقصى حد تسمح به الأنظمة السارية، ممارسة ذلك الحق وفق تقديرها المطلق؛
          (ز) لا تُطبَّق أي قاعدة تفسير في غير مصلحة طرف على أساس أن ذلك الطرف
          كان مسؤولًا عن إعداد هذه الشروط أو أي جزء منها.
        </p>
      </section>
      <section id="eligibility">
        <h2><span class="num">3</span> الأهلية والإقرارات المتعلقة بها</h2>
        <p>
          بوصولك إلى الخدمات أو استخدامك لها، فإنك تقرّ وتضمن وتتعهد، على نحو
          مستمر، بما يلي: (أ) أن عمرك ثمانية عشر (18) عامًا على الأقل؛ (ب) أنك
          تتمتع بكامل الحق والصلاحية والأهلية القانونية لإبرام هذه الشروط وتنفيذ
          التزاماتك بموجبها؛ (ج) أنك، إذا كنت تصل إلى الخدمات أو تستخدمها نيابةً
          عن شركة أو منظمة أو كيان قانوني آخر، مخوَّل حسب الأصول بإلزام ذلك
          الكيان بهذه الشروط، وفي هذه الحالة تشير عبارتا "أنت" و"الخاص بك" إلى
          ذلك الكيان وتشملانه؛ (د) أنه لا يوجد ما يحظر عليك أو على ذلك الكيان،
          أو يقيّد أيًا منكما، من الوصول إلى الخدمات أو استخدامها بموجب أي نظام
          سارٍ أو بموجب أي تعليق أو إنهاء سابق قررته شركة الخبرات الصاعدة لتقنية
          المعلومات. وتحتفظ شركة الخبرات الصاعدة لتقنية المعلومات، إلى أقصى حد
          تسمح به الأنظمة السارية، بالحق في رفض أي تسجيل، وفي التحقق من الأهلية
          في أي وقت، وفي تعليق الوصول أو إنهائه متى تبيّن عدم صحة أي من
          الإقرارات السابقة أو زوالها.
        </p>
      </section>
      <section id="services">
        <h2><span class="num">4</span> خدماتنا</h2>
        <h3 class="sub">
          <span class="n">4.1</span> لأصحاب العمل وجهات التوظيف
        </h3>
        <ul>
          <li>
            <b>البحث عن الكفاءات</b>: باقات اشتراك (<span class="en"
              >Professional</span
            >
            و<span class="en">Executive Pro</span>) توفّر إمكانية البحث والتصفية
            وفتح ملفات مرشحين موثَّقة، في حدود مخصّص باقتك الشهري من عمليات
            الفتح.
          </li>
          <li>
            <b>المقابلات والتقييمات</b>: مقابلات مسجّلة ذاتيًا مدعومة بالذكاء
            الاصطناعي وتقييمات تقنية وتقييمات نفسية قياسية (سيكومترية) تساعد
            الشركات على فرز المرشحين.
          </li>
          <li>
            <b>إدارة التوظيف</b>: أدوات لإدارة الإعلانات الوظيفية والمتقدمين
            ومسارات التوظيف.
          </li>
        </ul>
        <h3 class="sub"><span class="n">4.2</span> للباحثين عن عمل</h3>
        <ul>
          <li>
            <b>التقديم التلقائي</b>: اشتراك متجدّد يقوم فيه الذكاء الاصطناعي في
            شركة الخبرات الصاعدة لتقنية المعلومات بمطابقتك مع الوظائف وتخصيص
            سيرتك الذاتية لكل وظيفة وتقديم طلبات التوظيف نيابةً عنك، وفقًا
            للتفضيلات التي تحدّدها. ويشمل التقديم التلقائي وضع "الطيار الآلي"
            (<span class="en">Autopilot</span>) الذي تتم فيه عمليات تحديد
            الوظائف وتخصيص سيرتك الذاتية وتقديم الطلبات آليًا نيابةً عنك، دون
            مراجعة فردية لكل طلب، وذلك وفقًا للتفويض المبيَّن في القسم 7.1.
          </li>
          <li>
            <b>تحسين السيرة الذاتية</b>: خدمة لمرة واحدة تُنجَز بالكامل من
            جانبنا لتحسين سيرتك الذاتية وإعادة صياغتها في مُخرَج رقمي مخصَّص.
          </li>
        </ul>
        <p>
          يجوز لشركة الخبرات الصاعدة لتقنية المعلومات إضافة أي ميزة أو خدمة أو
          تعديلها أو تعليقها أو إيقافها، كليًا أو جزئيًا، في أي وقت، دون إشعار
          ودون أي مسؤولية من أي نوع. ولا يجوز لك استخدام الخدمات إلا للأغراض
          المشروعة ووفقًا لهذه الشروط.
        </p>
      </section>
      <section id="accounts">
        <h2><span class="num">5</span> حسابات المستخدمين</h2>
        <p>
          قد يتطلّب الوصول إلى بعض الميزات التسجيل للحصول على حساب. وعند
          التسجيل، فإنك توافق على:
        </p>
        <ul>
          <li>
            تقديم معلومات دقيقة وحديثة وكاملة وفقًا لما يطلبه نموذج التسجيل.
          </li>
          <li>الحفاظ على معلوماتك وتحديثها فورًا لتبقى دقيقة وحديثة وكاملة.</li>
          <li>
            الحفاظ على سرية بيانات الدخول الخاصة بك وعدم الإفصاح عنها لأي شخص
            آخر.
          </li>
          <li>تحمّل المسؤولية عن جميع الأنشطة التي تتم عبر حسابك.</li>
        </ul>
        <p>
          وأنت وحدك المسؤول عن جميع الأنشطة والأفعال وأوجه الامتناع التي تتم عبر
          حسابك أو من خلاله، سواء كانت بتصريح منك أم لا، ويحق لشركة الخبرات
          الصاعدة لتقنية المعلومات أن تعامل أي تعليمات أو تقديم أو مراسلة ترد
          عبر حسابك على أنها صادرة منك. ويجب عليك إخطارنا فورًا، بتقديم تذكرة
          دعم عبر <a routerLink="/contact-us">https://uptal.com/contact-us</a>،
          إذا اشتبهت في أي وصول أو استخدام غير مصرّح به لحسابك، وتظل، إلى حين
          ذلك الإخطار وإتاحة فرصة معقولة لشركة الخبرات الصاعدة لتقنية المعلومات
          للتصرف بناءً عليه، مسؤولًا عن جميع الأنشطة التي تتم عبر حسابك.
          ويُوجَّه ذلك الإخطار بالكيفية المبيَّنة في القسم 21. ولا تتحمّل شركة
          الخبرات الصاعدة لتقنية المعلومات المسؤولية عن أي خسارة أو ضرر ينشأ عن
          أي تقصير منك في حماية بيانات دخولك أو في تقديم ذلك الإخطار.
        </p>
      </section>
      <section id="payments">
        <h2><span class="num">6</span> المدفوعات والاشتراكات والاسترداد</h2>
        <h3 class="sub"><span class="n">6.1</span> الرسوم والفوترة</h3>
        <p>
          تتطلّب بعض الخدمات دفع رسوم. وباستخدامك أي خدمة مدفوعة، فإنك توافق على
          أن تدفع، وتفوّض شركة الخبرات الصاعدة لتقنية المعلومات ومعالجات الدفع
          لديها بأن تُحمِّل على وسيلة الدفع التي اخترتها، جميع الرسوم والمصاريف
          المطبَّقة، بما في ذلك الضرائب السارية، وفق الأسعار المعمول بها وقت
          استحقاق الرسم المعني، دون مقاصة أو خصم أو اقتطاع. وإذا تعذّر تحصيل أي
          رسم عند استحقاقه، جاز لشركة الخبرات الصاعدة لتقنية المعلومات تعليق
          الخدمة المعنية أو تقييدها إلى حين استلام المبلغ كاملًا، دون إخلال بأي
          حق أو وسيلة انتصاف أخرى. وتُفوتَر الاشتراكات (بما فيها البحث عن
          الكفاءات والتقديم التلقائي) على أساس متجدّد وتتجدّد تلقائيًا في نهاية
          كل دورة فوترة ما لم تُلغَ قبل التجديد. ويسري الإلغاء في نهاية فترة
          الفوترة الحالية، وتحتفظ بالوصول حتى انتهاء فترتك المدفوعة. ويمكنك
          الإلغاء في أي وقت من إعدادات حسابك لدى شركة الخبرات الصاعدة لتقنية
          المعلومات، عبر المسار: الحساب، ثم الفوترة، ثم إلغاء الاشتراك. ويتم
          الإلغاء من المشترك نفسه، شخصيًا، باستخدام خاصية الإلغاء الذاتي في
          إعدادات حسابه لدى شركة الخبرات الصاعدة لتقنية المعلومات، وهي الوسيلة
          الوحيدة لإلغاء أي اشتراك. ولا يملك أي موظف أو مسؤول أو وكيل أو متعاقد
          أو ممثل أو موزّع أو مساعد آلي أو عضو في فريق الدعم لدى شركة الخبرات
          الصاعدة لتقنية المعلومات صلاحية أو إذنًا بإلغاء اشتراك، أو بالموافقة
          على إلغائه، بناءً على طلب مشترك أو نيابةً عنه، وأي إفادة صادرة عن أي
          من هؤلاء تفيد بأنه ألغى اشتراكًا، أو أنه بصدد إلغائه، أو أن بإمكانه
          إلغاءه، هي إفادة غير مصرّح بها، ولا أثر لها، ولا تُلزم شركة الخبرات
          الصاعدة لتقنية المعلومات، ولا تُعدّ إلغاءً. وتقديم تذكرة دعم عبر
          <a routerLink="/contact-us">https://uptal.com/contact-us</a>، أيًا كان
          نوع سببها وأيًا كان مضمونها، ليس إلغاءً: فهو لا يلغي اشتراكًا، ولا
          يوقف الفوترة، ولا يمنع تجديدًا. ويحكم القسم 4 من سياسة الاسترداد
          التجديدات، والموعد النهائي للإلغاء قبل التجديد، وما لا يُعدّ إلغاءً،
          والوضع في حال عدم توافر خاصية الإلغاء في حسابك، ونتائج التخلّف عن
          الإلغاء.
        </p>
        <h3 class="sub"><span class="n">6.2</span> عدم الاسترداد</h3>
        <div class="callout">
          جميع المدفوعات مقابل جميع خدمات شركة الخبرات الصاعدة لتقنية المعلومات
          نهائية وغير قابلة للاسترداد. فخدمات شركة الخبرات الصاعدة لتقنية
          المعلومات خدمات رقمية بوصول فوري وتُعامَل على أنها مُستخدَمة منذ لحظة
          الشراء. وكل خدمة من خدمات شركة الخبرات الصاعدة لتقنية المعلومات خدمة
          رقمية تُسلَّم بالكامل، وتُؤدَّى بالكامل، وتُقبَل بالكامل، وتُستهلَك
          استهلاكًا لا رجعة فيه، في لحظة تحصيل الدفعة بنجاح، في الشراء الأول وفي
          كل تجديد على حد سواء، وإتاحة الخدمة، لا استخدامك لها، هي معيار ذلك
          الأداء. ولا يُصدَر أي مبلغ مسترد عن أي خدمة من خدمات شركة الخبرات
          الصاعدة لتقنية المعلومات، لأي سبب وفي أي وقت، ولا يُصدَر بديلًا عنه أي
          عكس للعملية، أو رصيد، أو قسيمة، أو كوبون، أو خصم، أو رصيد في الحساب،
          أو تمديد للمدة، أو فترة مجانية، أو مقاصة، أو حسم، أو حجز، أو تعويض، أو
          تعويض بديل عن الضرر، أو بادرة حسن نية. وتنص سياسة الاسترداد على تصحيح
          حالتَي فوترة لا تمثلان في الأصل دفعًا مقابل أي خدمة على الإطلاق، وهما:
          رسم مكرّر، أيًا كان سبب التكرار، بما في ذلك نشوؤه عن خطأ في أنظمة
          الفوترة لدى شركة الخبرات الصاعدة لتقنية المعلومات، أو عن تكرار الإرسال
          عند الدفع، أو عن تكرار التحصيل من قِبل مزوّد خدمة الدفع، ورسم يثبت،
          بعد تحقيق شركة الخبرات الصاعدة لتقنية المعلومات، أنه تم دون تفويض من
          الدافع المسجَّل؛ وهذان التصحيحان ليسا استردادًا صراحةً، وليسا استثناءً
          من هذا القسم، ولا يُجريان إلا وفق الشروط المبيَّنة في القسم 10 من
          سياسة الاسترداد. وكذلك فإن أي مبلغ يُعاد بموجب القسم 4.16 أو القسم 9.7
          أو القسم 15.11 من سياسة الاسترداد ليس استردادًا لأي خدمة من خدمات شركة
          الخبرات الصاعدة لتقنية المعلومات، وليس استثناءً من هذا القسم، ولا
          يُعاد إلا وفق الشروط المبيَّنة في القسم المعني. وليس في هذه الشروط ولا
          في سياسة الاسترداد ما يحدّ أو يستثني أي حق أو وسيلة انتصاف يكفلها لك
          حكم من أحكام أنظمة المملكة العربية السعودية يكون إلزاميًا ولا يمكن
          التنازل عنه أو تقييده أو تعديله بالاتفاق.
        </div>
        <h3 class="sub">
          <span class="n">6.3</span> الأسعار وضريبة القيمة المضافة وتغييراتها
        </h3>
        <p>
          جميع الأسعار لا تشمل ضريبة القيمة المضافة (<span class="en">VAT</span
          >). وتُضاف ضريبة القيمة المضافة المطبَّقة (بنسبة 15% حاليًا) عند
          الدفع، وتُصدَر فاتورة ضريبية نظامية عن كل عملية دفع. ويجوز لشركة
          الخبرات الصاعدة لتقنية المعلومات تعديل الأسعار في أي وقت دون إشعار
          مسبق. والسعر الساري لأي عملية شراء جديدة هو السعر المعروض لك عند الدفع
          لتلك العملية. والتفويض الذي تمنحه لأي اشتراك هو تفويض بتحصيل مبلغ
          محدّد ومذكور، على فترة زمنية محدّدة ومذكورة، يُعرَضان عليك كلاهما عند
          الدفع، وتقبلهما قبل السداد، ويُدوَّنان في تأكيد عملية الشراء، ويظهران
          في حسابك لدى شركة الخبرات الصاعدة لتقنية المعلومات. ويُحصَّل كل رسم
          تجديد بالمبلغ المصرّح به نفسه، وعلى الفترة المصرّح بها نفسها. ولا يسري
          أي تغيير في سعر باقة على تجديدات اشتراك قائم لديك إلا اعتبارًا من
          اللحظة التي يُعرَض فيها عليك السعر الجديد بوصفه المبلغ الذي سيسري على
          تجديداتك المستقبلية، وتقبله فيها بفعل إيجابي منفصل، وهما معًا يشكّلان
          تفويضًا متجدّدًا، على النحو الذي يحدث عند الترقية، أو الرجوع إلى باقة
          أدنى، أو تغيير الباقة، أو تغيير دورية الفوترة، أو إضافة مقعد أو
          إزالته، أو إعادة التفعيل، أو الاستئناف بعد إيقاف مؤقت، أو إعادة إدخال
          بيانات الدفع أو استبدالها، متى عُرض المبلغ الجديد وقُبل قبولًا منفصلًا
          في ذلك الوقت. وإلى حين منح تفويض متجدّد، يُحصَّل كل رسم تجديد لذلك
          الاشتراك بالمبلغ الأخير الذي صرّحت به لتلك الباقة. ولا يُعدّ التحديث
          التلقائي لبيانات البطاقة، أو إعادة إصدارها، أو استبدالها، سواء تم منك
          أو من جهة إصدار بطاقتك أو عبر خدمة تحديث بيانات الحسابات التي تشغّلها
          شبكة بطاقات أو مزوّد دفع، تفويضًا متجدّدًا، ولا يغيّر المبلغ الذي
          صرّحت به. ويحكم هذا القسمَ القسمُ 13.2 من سياسة الاسترداد.
        </p>
        <h3 class="sub">
          <span class="n">6.4</span> الفترات التجريبية المجانية
        </h3>
        <p>
          يجوز لشركة الخبرات الصاعدة لتقنية المعلومات تقديم فترات تجريبية أو
          ميزات مجانية وفق تقديرها. ولا تتحوّل الفترات التجريبية المجانية إلى
          اشتراكات مدفوعة إلا حيثما يُفصَح عن ذلك بوضوح قبل تقديمك بيانات الدفع.
          ويجوز لشركة الخبرات الصاعدة لتقنية المعلومات تعديل العروض المجانية أو
          سحبها في أي وقت.
        </p>
        <h3 class="sub"><span class="n">6.5</span> ردّ المدفوعات</h3>
        <p>
          إذا كان لديك أي استفسار أو سؤال أو نزاع يتعلق بالفوترة، بما في ذلك رسم
          لا تتعرّف عليه في كشف حسابك أو في تطبيق بنكك، فينبغي لك أولًا تقديم
          تذكرة دعم عبر
          <a routerLink="/contact-us">https://uptal.com/contact-us</a>، مع
          اختيار سبب التواصل "الفوترة والمدفوعات"، وذلك قبل التواصل مع بنكك أو
          جهة إصدار بطاقتك أو مزوّد الدفع أو شبكة البطاقات أو مزوّد خدمة التقسيط
          أو المحفظة أو متجر التطبيقات، وينبغي لك أن تتيح لشركة الخبرات الصاعدة
          لتقنية المعلومات فرصة للمراجعة والرد، وهي خمسة (5) أيام عمل من تاريخ
          استلام التذكرة. وحيثما لم تردّ شركة الخبرات الصاعدة لتقنية المعلومات
          ردًا موضوعيًا خلال تلك المدة، وهي خمسة (5) أيام عمل، فإن هذا القسم لا
          يمنعك من التواصل مع بنكك أو جهة إصدار بطاقتك أو مزوّد الدفع. وإذا
          قُدِّم طلب ردّ مدفوعات أو نزاع دفع أو طلب عكس بشأن رسم صحيح بموجب
          سياسة الاسترداد وهذه الشروط، فقد نوقف وصولك إلى الخدمة المعنية أو
          نقيّده ريثما نُجري التحقّق، وحيثما تبيّن أن الرسم محلّ النزاع صحيح،
          فقد نسترد منك، بوصفه دَينًا مستحق الأداء عند الطلب، المبلغ المستحق مع
          ما تكبّدته شركة الخبرات الصاعدة لتقنية المعلومات فعليًا من تكاليف
          ومصروفات إدارية وتحقيقية وتحصيلية وقانونية معقولة وموثّقة في سبيل
          استرداد ذلك المبلغ، ولا يسقط المبلغ المستحق بتقديم النزاع ولا بنتيجته.
          ولا تسترد شركة الخبرات الصاعدة لتقنية المعلومات منك، ولا تفرض عليك، أي
          رسم لردّ المدفوعات أو رسم نزاع أو رسم إعادة تقديم أو رسم تحكيم أو
          غرامة أو جزاء يفرضه على شركة الخبرات الصاعدة لتقنية المعلومات أي مزوّد
          دفع أو بنك مستحوذ أو شبكة بطاقات، ولا تفرض أي رسم مقابل تقديم النزاع
          نفسه. ولا ينطبق هذا القسم على البلاغ عن احتيال، أو عن ضياع أداة دفع أو
          سرقتها، ولا على إشعار مزوّد خدمة الدفع بعملية دفع غير مصرّح بها، ولا
          على طلب يُقدَّم إلى مزوّد خدمة دفع بموجب اللائحة التنفيذية لنظام
          المدفوعات وخدمات المدفوعات في المملكة العربية السعودية، ولا على شكوى
          تُقدَّم إلى أي جهة مختصة في المملكة العربية السعودية، ولا يؤخّر أيًا
          منها. ويخضع ردّ المدفوعات ونزاعات الدفع خضوعًا كاملًا لأحكام القسم 11
          من سياسة الاسترداد، ويكون لمصطلح "يوم العمل" المعنى المبيَّن له في
          سياسة الاسترداد.
        </p>
      </section>
      <section id="jobseekers">
        <h2>
          <span class="num">7</span> خدمات الباحثين عن عمل: التقديم التلقائي
          وتحسين السيرة الذاتية
        </h2>
        <h3 class="sub">
          <span class="n">7.1</span> تفويضك لشركة الخبرات الصاعدة لتقنية
          المعلومات ونطاق الوكالة
        </h3>
        <p>
          باشتراكك في التقديم التلقائي أو تفعيلك له أو تمكينه بأي شكل آخر، وعلى
          وجه الخصوص باختيارك وضع "الطيار الآلي" (<span class="en"
            >Autopilot</span
          >) في التقديم التلقائي أو تفعيلك له أو تشغيلك إياه، فإنك تفوّض شركة
          الخبرات الصاعدة لتقنية المعلومات تفويضًا صريحًا وغير مشروط بأن تقوم،
          من خلال أنظمة الذكاء الاصطناعي لديها والعاملين لديها، بكل من الأفعال
          التالية نيابةً عنك وباسمك، وفي كل حالة وفقًا للتفضيلات والمرشّحات
          ومعايير الاستهداف التي تضبطها في حسابك من وقت لآخر وفي حدود النطاق
          الذي تحدّده: (أ) تحديد الوظائف الشاغرة والفرص المماثلة التي تقيّمها
          أنظمة الذكاء الاصطناعي على أنها مطابقة لملفك وسيرتك الذاتية وتفضيلاتك
          المعلنة، وتقييمها واختيارها؛ (ب) إنشاء نسخ من سيرتك الذاتية وموادك
          المصاحبة وبيانات طلبك وتكييفها وإعادة تنسيقها وتخصيصها لوظائف محدّدة؛
          (ج) استكمال الطلبات وتعبئتها وتقديمها، بما فيها سيرتك الذاتية
          المخصَّصة وبيانات طلبك وما تتضمنه من بيانات شخصية، إلى أصحاب العمل
          وأنظمة تتبّع المتقدمين ومنصات التوظيف؛ (د) إرسال الطلبات إلى مستلمين
          داخل المملكة العربية السعودية أو خارجها حيثما استهدفت تفضيلاتك تلك
          الوظائف؛ (هـ) اتخاذ ما يلزم أو يُستحسَن من خطوات تبعية وعرضية بشكل
          معقول لإنفاذ ما سبق. ويمكنك تعديل تفضيلات الاستهداف أو الإيقاف المؤقت
          أو الإلغاء في أي وقت من حسابك، على أن يسري ذلك على الطلبات المستقبلية
          فقط. ويُعدّ منح هذا التفويض شرطًا إلزاميًا لاستخدام التقديم التلقائي
          في وضع الطيار الآلي: فلا يمكن اختيار وضع الطيار الآلي أو تفعيله أو
          تشغيله دون هذا التفويض؛ ويشكّل اختيارك لوضع الطيار الآلي أو تفعيلك له
          منحًا صريحًا منك لهذا التفويض؛ وإذا لم توافق على منحه، فيجب عليك عدم
          اختيار وضع الطيار الآلي أو تفعيله أو تشغيله.
        </p>
        <p>
          تقرّ وتوافق على أن التقديم التلقائي يعمل آليًا وباستمرار ودون مراجعة
          أو موافقة أو تأكيد فردي منك لكل طلب قبل تقديمه، وأنه قد يقدّم تبعًا
          لذلك طلبات إلى وظائف أو أصحاب عمل أو جهات لم تراجعها بشكل فردي، أو لم
          تكن لتختارها بنفسك، أو لا ترغب فيها. ويتحدّد نطاق التقديم وحجمه
          وتوقيته ووجهته بناءً على ملفك وسيرتك الذاتية وإعدادات تفضيلاتك كما هي
          قائمة وقت كل تقديم، وأنت وحدك وحصريًا المسؤول عن ضمان دقتها واكتمالها
          وحداثتها في جميع الأوقات. ولا يكون للإيقاف المؤقت للتقديم التلقائي أو
          لإلغائه أي أثر أيًا كان على أي طلب قُدِّم قبل نفاذ ذلك الإيقاف أو
          الإلغاء.
        </p>
        <h3 class="sub">
          <span class="n">7.2</span> المخرجات المولَّدة بالذكاء الاصطناعي
          ودقتها؛ عدم الاعتماد عليها
        </h3>
        <div class="callout">
          أنظمة الذكاء الاصطناعي في شركة الخبرات الصاعدة لتقنية المعلومات
          احتمالية بطبيعتها وقد ترتكب أخطاء. فهي تعمل بأساليب إحصائية وأساليب
          تعلّم آلة غير حتمية بطبيعتها؛ وقد تؤدي المدخلات المتطابقة أو المتشابهة
          إلى مخرجات مختلفة، وتُولَّد المخرجات دون مراجعة بشرية لكل نتيجة على
          حدة. وجميع المخرجات، بما فيها مطابقات الوظائف ودرجات التوافق والترتيب
          والتقييمات والسير الذاتية المخصَّصة، هي تقديرات وتقريبات فقط، وتُقدَّم
          لأغراض المعلومات العامة، وقد تتضمن أخطاء أو سهوًا أو أوصافًا غير صحيحة
          أو نتائج غير دقيقة أو غير مكتملة أو غير محدَّثة أو غير مناسبة بأي شكل
          آخر. والمطابقة ليست مضمونة الدقة أو الشمول أو المثالية أبدًا؛ ولا تعني
          درجة التوافق المرتفعة أن الوظيفة مناسبة لك، أو أنك مناسب لها، أو أنك
          مستوفٍ لمتطلباتها، أو أن الوظيفة قائمة أو لا تزال متاحة أو موصوفة
          وصفًا صحيحًا من صاحب العمل أو المنصة المعنية. ولا تشكّل أي مخرجات
          مشورة مهنية أو وظيفية أو قانونية أو غيرها، ولا يجوز الاعتماد عليها
          بهذه الصفة. وأنت المسؤول عن مراجعة المخرجات والإعدادات التي توجّه عمل
          الخدمات والتحقق منها بالقدر الذي تراه مناسبًا. ولا تقدّم شركة الخبرات
          الصاعدة لتقنية المعلومات أي تعهد أو ضمان أو التزام من أي نوع، صريحًا
          كان أو ضمنيًا، بأن أي مخرجات دقيقة أو كاملة أو حديثة أو موثوقة أو
          خالية من الأخطاء أو ملائمة لأي غرض معيّن، وتُخلي، إلى أقصى حد تسمح به
          الأنظمة السارية، مسؤوليتها عن أي التزام ينشأ عن أي اعتماد على أي
          مخرجات أو فيما يتصل بذلك.
        </div>
        <h3 class="sub">
          <span class="n">7.3</span> نهائية الطلبات المقدَّمة وعدم قابليتها
          للإلغاء
        </h3>
        <div class="callout">
          بمجرد تقديم الطلب، يصبح نهائيًا وغير قابل للإلغاء، ولا يمكن سحبه أو
          استرجاعه أو تعديله أو تحريره أو حذفه من قبل شركة الخبرات الصاعدة
          لتقنية المعلومات. فبمجرد التقديم، يغادر الطلب أنظمة شركة الخبرات
          الصاعدة لتقنية المعلومات وينتقل إلى حيازة وسيطرة أصحاب عمل وأنظمة
          تتبّع متقدمين ومنصات تابعة لأطراف ثالثة لا تمارس شركة الخبرات الصاعدة
          لتقنية المعلومات عليها أي سيطرة، ولا يكون لشركة الخبرات الصاعدة لتقنية
          المعلومات تجاهها أي حق أو قدرة أو التزام بالاسترجاع أو التصحيح أو
          الحذف. وأي طلب لسحب طلب مقدَّم أو تعديله أو تصحيحه يجب أن تقدّمه أنت
          مباشرةً إلى صاحب العمل أو المنصة المستلمة، وفقًا لإجراءات ذلك المستلم،
          ولا يقع على شركة الخبرات الصاعدة لتقنية المعلومات أي التزام بتحقيق ذلك
          ولا تقدّم أي تأكيد بشأن نجاح أي طلب من هذا القبيل. ولن يُصدَر أي
          استرداد أو رصيد أو تعويض من أي نوع فيما يتعلق بأي طلب مقدَّم، بما في
          ذلك أي طلب قُدِّم إلى وظيفة أو صاحب عمل أو جهة لم ترغب فيها أو لم تكن
          لتختارها بنفسك أو لم تراجعها بشكل فردي، وتتنازل بشكل نهائي، وتُبرئ ذمة
          شركة الخبرات الصاعدة لتقنية المعلومات وتُحلّها، إلى أقصى حد تسمح به
          الأنظمة السارية، من أي مطالبة تنشأ عن أي تقديم تم وفقًا للتفويض
          المبيَّن في القسم 7.1 أو فيما يتصل به.
        </div>
        <h3 class="sub">
          <span class="n">7.4</span> إقراراتك وضماناتك وتعهداتك
        </h3>
        <p>
          تقرّ وتضمن وتتعهد، على نحو مستمر، بما يلي: (أ) أن جميع المعلومات
          الواردة في سيرتك الذاتية وملفك وحسابك صحيحة ودقيقة وكاملة وحديثة وستظل
          كذلك، وتقرّ بأن السير الذاتية المخصَّصة وغيرها من المخرجات تُنشأ من
          المعلومات التي تقدّمها واعتمادًا عليها، وأنك وحدك المسؤول عن دقتها؛
          (ب) أنك تحوز، وستظل تحوز، جميع الحقوق والتصاريح والاستحقاقات اللازمة
          للسعي إلى العمل وتولّيه في كل موقع تستهدفه؛ (ج) أنك ستراجع حسابك وسجل
          طلباتك وإعدادات تفضيلاتك بانتظام وستُبقي تفضيلاتك محدَّثة؛ (د) أنك لن
          تستخدم التقديم التلقائي أو تحسين السيرة الذاتية لتقديم أي معلومات
          كاذبة أو مضلّلة أو احتيالية أو التسبب في تقديمها؛ (هـ) أنك ستلتزم
          بجميع الأنظمة السارية فيما يتعلق باستخدامك للخدمات وبأي عمل تحصل عليه
          من خلالها.
        </p>
        <h3 class="sub"><span class="n">7.5</span> عدم ضمان النتائج</h3>
        <div class="callout">
          لا تضمن شركة الخبرات الصاعدة لتقنية المعلومات مقابلات أو عروض عمل أو
          توظيفًا. فالتقديم التلقائي يتولى تقديم الطلبات، وتحسين السيرة الذاتية
          يطوّر عرض سيرتك الذاتية؛ أما جميع قرارات الفرز والترشيح والمقابلة
          والتوظيف فتُتَّخذ من قبل أصحاب العمل وحدهم، وفق تقديرهم المطلق، وخارج
          علم شركة الخبرات الصاعدة لتقنية المعلومات وسيطرتها. وتتفاوت أعداد
          الوظائف المطابَقة وأعداد الطلبات المخصَّصة أو المقدَّمة ومعدلات
          الاستجابة ومعدلات المقابلات ونتائج التوظيف، وتعتمد على عوامل خارجة عن
          سيطرة شركة الخبرات الصاعدة لتقنية المعلومات، وليست مضمونة، ولا يجوز
          تفسير أي بيان على الموقع الإلكتروني أو داخل الخدمات على أنه ضمان أو
          تعهد أو تأكيد لأي حجم أو معدل أو نتيجة بعينها.
        </div>
        <h3 class="sub">
          <span class="n">7.6</span> رفع السيرة الذاتية ومعاينة المطابقات
          والإدراج في قاعدة الكفاءات لدى شركة الخبرات الصاعدة لتقنية المعلومات
        </h3>
        <p>
          برفعك سيرتك الذاتية أو ملفك أو المعلومات المرتبطة بهما إلى شركة
          الخبرات الصاعدة لتقنية المعلومات أو تقديمها أو مزامنتها عبر أي جزء من
          الخدمات، بما في ذلك عبر موقع التقديم التلقائي بغرض معاينة عدد مطابقات
          الوظائف المتاحة لك أو طبيعتها أو التحقق منها، وسواء اشتركت لاحقًا في
          أي خدمة مدفوعة أو اشتريتها أم لا، فإنك تقرّ وتوافق على أن شركة الخبرات
          الصاعدة لتقنية المعلومات ستعالج تلك المعلومات وتخزّنها، وعلى أنه يجوز
          لشركة الخبرات الصاعدة لتقنية المعلومات إدراج ملفك وسيرتك الذاتية
          والبيانات المرتبطة بهما في قاعدة بيانات المرشحين وقاعدة الكفاءات
          لديها، وإتاحتها أو جعلها قابلة للاكتشاف أو عرضها بأي شكل آخر، كليًا أو
          جزئيًا، على أصحاب العمل وجهات التوظيف وغيرهم من المشتركين الذين يبحثون
          عن مرشحين بمهاراتك أو خبراتك أو سماتك، وذلك عبر البحث عن الكفاءات
          وغيره من خدمات شركة الخبرات الصاعدة لتقنية المعلومات الحالية أو
          المستقبلية. وتتم هذه الإتاحة وهذا الإفصاح وفقًا لـ<a
            routerLink="/privacy-policy"
            >سياسة الخصوصية</a
          >
          وفي الحدود الموضحة فيها، بما في ذلك الأحكام التي تحدّد البيانات
          الظاهرة للمشتركين والبيانات التي لا يُفصَح عنها إلا عند فتح الملف.
          وتقرّ بأن المعلومات التي ترفعها دقيقة وأنه يحق لك تقديمها، ويمكنك
          ممارسة الحقوق المتاحة لك بموجب سياسة الخصوصية والأنظمة السارية، بما في
          ذلك طلب إزالة ملفك من قاعدة الكفاءات، في أي وقت.
        </p>
        <h3 class="sub">
          <span class="n">7.7</span> مُخرَجات تحسين السيرة الذاتية؛ الحل الحصري
        </h3>
        <p>
          تُنتِج خدمة تحسين السيرة الذاتية مُخرَجًا رقميًا مخصَّصًا يُعَدّ بناءً
          على المعلومات التي تقدّمها واعتمادًا عليها. وتقرّ بأن تقييم أسلوب
          السيرة الذاتية وعرضها وقوة إقناعها أمر ذاتي بطبيعته. وإذا لم تكن
          راضيًا عن مُخرَج تحسين السيرة الذاتية، فإن الحل الوحيد والحصري المتاح
          لك، وكامل مسؤولية شركة الخبرات الصاعدة لتقنية المعلومات في هذا الشأن،
          هو تقديم المراجعات وفقًا لنطاق الخدمة التي اشتريتها، وليس أي استرداد
          أو رصيد أو تعويض آخر، وذلك كله وفقًا لما هو مبيَّن في القسم 9.3 من
          سياسة الاسترداد. ولا يُقدَّم أي ضمان لتحسّن الدرجة، ولا ضمان للرضا،
          ولا ضمان لاسترداد المال، ولا فترة تجربة بلا مخاطر، فيما يتعلق بتحسين
          السيرة الذاتية أو بأي خدمة أخرى من خدمات شركة الخبرات الصاعدة لتقنية
          المعلومات. ويظل أي طلب قُدّم قبل 7 سبتمبر 2026 محكومًا بنسخة سياسة
          الاسترداد المنشورة وقت ذلك الطلب، وفقًا للقسم 9.7 من سياسة الاسترداد.
        </p>
      </section>
      <section id="acceptable-use">
        <h2><span class="num">8</span> الاستخدام المقبول والأنشطة المحظورة</h2>
        <h3 class="sub"><span class="n">8.1</span> محظورات عامة</h3>
        <p>توافق على عدم استخدام الخدمات:</p>
        <ul>
          <li>
            بأي طريقة تنتهك أي نظام أو لائحة سارية في المملكة العربية السعودية
            أو دوليًا.
          </li>
          <li>
            للانخراط في أي سلوك يقيّد استخدام أي شخص للخدمات أو استمتاعه بها، أو
            قد يضرّ بشركة الخبرات الصاعدة لتقنية المعلومات أو بمستخدمي الخدمات،
            أو يعرّضهم للمسؤولية.
          </li>
          <li>
            بأي طريقة قد تعطّل الخدمات أو تثقلها أو تتلفها أو تضعفها، أو تتداخل
            مع استخدام أي طرف آخر للخدمات.
          </li>
          <li>
            لتقديم معلومات كاذبة أو مضلّلة أو احتيالية، بما في ذلك في السير
            الذاتية أو الملفات أو طلبات التوظيف.
          </li>
        </ul>
        <h3 class="sub"><span class="n">8.2</span> الأنشطة التقنية المحظورة</h3>
        <p>
          توافق على عدم الانخراط في أي نشاط يمسّ بالاستخدام المقصود للخدمات أو
          أمنها أو تشغيلها، أو يتداخل مع أي من ذلك، أو يحاول الالتفاف عليه.
          وتشمل الأنشطة المحظورة، على سبيل المثال لا الحصر:
        </p>
        <ul>
          <li>
            <b>الوصول غير المصرّح به إلى واجهات البرمجة</b>: الوصول أو محاولة
            الوصول إلى الخدمات أو أي واجهة برمجة تطبيقات (<span class="en"
              >API</span
            >) باستخدام أدوات مثل <span class="en">Postman</span> أو
            <span class="en">cURL</span> أو النصوص البرمجية أو العملاء
            المخصَّصين أو إضافات المتصفح أو أي وسيلة أخرى لم تصرّح بها شركة
            الخبرات الصاعدة لتقنية المعلومات صراحةً.
          </li>
          <li>
            <b>الاستخلاص وجمع البيانات</b>: تنزيل البيانات من الخدمات أو
            استخراجها أو تصديرها أو التنقيب فيها أو فهرستها أو جمعها بأي شكل
            آخر، يدويًا أو بوسائل آلية، بما في ذلك الروبوتات أو الزواحف أو
            العناكب.
          </li>
          <li>
            <b>الهندسة العكسية</b>: محاولة فك الترجمة البرمجية للخدمات أو فك
            تجميعها أو إجراء هندسة عكسية لها، أو استخلاص الشيفرة المصدرية أو
            البنية أو النماذج أو منطق احتساب الدرجات أو الخوارزميات التي
            تستخدمها شركة الخبرات الصاعدة لتقنية المعلومات بأي طريقة أخرى، بما
            في ذلك آليات الذكاء الاصطناعي والتقييم.
          </li>
          <li>
            <b>تجاوز الأمن أو الحدود</b>: الالتفاف على المصادقة أو التخويل أو
            حدود المعدلات أو حصص الاستخدام أو المراقبة أو أي تدابير حماية أمنية
            أو تقنية، أو تعطيلها أو التداخل معها.
          </li>
          <li>
            <b>الاختبار الأمني غير المصرّح به</b>: إجراء اختبارات اختراق أو فحص
            ثغرات أو اختبارات تحميل أو ما يماثلها دون موافقة كتابية مسبقة من
            شركة الخبرات الصاعدة لتقنية المعلومات.
          </li>
        </ul>
        <p>
          يشكّل أي نشاط من هذا القبيل إخلالًا جوهريًا بهذه الشروط، وقد يشكّل
          أيضًا انتهاكًا لنظام مكافحة الجرائم المعلوماتية السعودي وأنظمة حماية
          البيانات والملكية الفكرية السارية. ودون إخلال بأي حق أو وسيلة انتصاف
          أخرى متاحة لها، يجوز لشركة الخبرات الصاعدة لتقنية المعلومات التحقيق في
          أي انتهاك مشتبه به لهذا القسم، وتعليق الوصول أو إنهاؤه وفقًا للقسم 14
          أثناء ذلك التحقيق أو بعده، وحفظ المعلومات ذات الصلة والإفصاح عنها
          للجهات المختصة بالقدر الذي تجيزه الأنظمة السارية أو تقتضيه، ويحق لها
          طلب الانتصاف الزجري وغيره من أوجه الانتصاف العادلة، إضافةً إلى
          التعويضات، في مواجهة أي انتهاك فعلي أو وشيك، مع الإقرار بأن التعويضات
          وحدها قد لا تكون انتصافًا كافيًا.
        </p>
      </section>
      <section id="ip">
        <h2><span class="num">9</span> الملكية الفكرية والتراخيص</h2>
        <h3 class="sub">
          <span class="n">9.1</span> ملكية شركة الخبرات الصاعدة لتقنية المعلومات
        </h3>
        <p>
          جميع المحتويات والمواد المقدَّمة على الخدمات أو من خلالها، بما في ذلك
          النصوص والرسومات والشعارات والأيقونات والصور والمقاطع الصوتية والمرئية
          وتجميعات البيانات والبرمجيات والخوارزميات وتصاميم واجهات الاستخدام، هي
          ملك لشركة الخبرات الصاعدة لتقنية المعلومات أو لمرخِّصيها، ومحمية بموجب
          أنظمة حقوق النشر والملكية الفكرية السعودية والدولية.
        </p>
        <h3 class="sub"><span class="n">9.2</span> ترخيصك لاستخدام الخدمات</h3>
        <p>
          تمنحك شركة الخبرات الصاعدة لتقنية المعلومات ترخيصًا محدودًا وغير حصري
          وغير قابل للتحويل وقابلًا للإلغاء للوصول إلى الخدمات واستخدامها لأغراض
          أعمالك الداخلية (للمشتركين) أو لبحثك الشخصي غير التجاري عن عمل
          (للباحثين عن عمل). ولا يشمل هذا الترخيص أي حق في إعادة إنتاج محتوانا
          أو تعديله أو توزيعه أو عرضه علنًا أو إنشاء أعمال مشتقة منه إلا بإذن
          كتابي صريح من شركة الخبرات الصاعدة لتقنية المعلومات.
        </p>
        <h3 class="sub"><span class="n">9.3</span> المحتوى الخاص بك</h3>
        <p>
          تحتفظ بملكية المحتوى الذي تقدّمه إلى الخدمات، بما في ذلك سيرتك
          الذاتية. وبتقديمك المحتوى، فإنك تمنح شركة الخبرات الصاعدة لتقنية
          المعلومات ترخيصًا عالميًا وغير حصري وخاليًا من الرسوم لاستضافة ذلك
          المحتوى وتخزينه ومعالجته وتكييفه ونقله بالقدر اللازم لتقديم الخدمات،
          بما في ذلك إنشاء نسخ مخصَّصة من سيرتك الذاتية وتقديمها إلى أصحاب العمل
          بناءً على تعليماتك (التقديم التلقائي)، وإنتاج سيرتك الذاتية المُحسّنة
          (تحسين السيرة الذاتية). ويظل هذا الترخيص ساريًا بعد إنهاء هذه الشروط
          بالقدر اللازم فقط لامتثال شركة الخبرات الصاعدة لتقنية المعلومات
          للأنظمة السارية، والاحتفاظ بسجلاتها التجارية، وإنفاذ حقوقها أو الدفاع
          عنها.
        </p>
        <h3 class="sub"><span class="n">9.4</span> الملاحظات والمقترحات</h3>
        <p>
          إذا قدّمت لشركة الخبرات الصاعدة لتقنية المعلومات أي اقتراحات أو أفكار
          أو طلبات تحسين أو توصيات أو غير ذلك من الملاحظات المتعلقة بالخدمات
          ("الملاحظات")، فإنك تمنح شركة الخبرات الصاعدة لتقنية المعلومات ترخيصًا
          دائمًا وغير قابل للإلغاء وعالميًا ومعفى من الرسوم ومدفوعًا بالكامل
          وقابلًا للترخيص من الباطن وللنقل، لاستخدام تلك الملاحظات ونسخها
          وتعديلها وتكييفها ونشرها واستغلالها بأي شكل آخر ولأي غرض، دون قيد أو
          إسناد أو مقابل، وتتنازل، إلى أقصى حد تسمح به الأنظمة السارية، عن أي
          حقوق أدبية أو حقوق مماثلة في تلك الملاحظات.
        </p>
      </section>
      <section id="privacy">
        <h2><span class="num">10</span> الخصوصية وحماية البيانات الشخصية</h2>
        <p>
          يخضع استخدامك للخدمات أيضًا لـ<a routerLink="/privacy-policy"
            >سياسة الخصوصية</a
          >
          الخاصة بنا، التي توضّح كيفية جمعنا للبيانات الشخصية واستخدامها
          والإفصاح عنها. وباستخدامك الخدمات، فإنك تقرّ بأن بياناتك الشخصية
          ستُعالَج وفقًا لما هو موضّح في سياسة الخصوصية، وبالاستناد إلى الأسس
          النظامية المبيَّنة فيها، وبما يتوافق مع نظام حماية البيانات الشخصية
          السعودي ولوائحه التنفيذية.
        </p>
      </section>
      <section id="custodianship">
        <h2><span class="num">11</span> حفظ البيانات ومخرجات المنصة</h2>
        <div class="note">
          مهم: بموجب نظام حماية البيانات الشخصية، تخضع البيانات الشخصية لحقوق
          أصحاب البيانات والتزامات المعالجة المشروعة. وتهدف هذه الشروط إلى توضيح
          الحقوق والمسؤوليات؛ وهي لا تنقل ملكية البيانات الشخصية.
        </div>
        <h3 class="sub"><span class="n">11.1</span> بيانات المرشحين وحفظها</h3>
        <ul>
          <li>
            البيانات الشخصية المتعلقة بالمرشحين ليست ملكًا للعملاء، ولا يكتسب
            العملاء أي حقوق ملكية أو حقوق عينية في البيانات الشخصية للمرشحين
            بحكم استخدامهم للخدمات.
          </li>
          <li>
            يحتفظ المرشحون بحقوقهم كأصحاب بيانات بموجب أنظمة حماية البيانات
            السارية.
          </li>
          <li>
            تعمل شركة الخبرات الصاعدة لتقنية المعلومات بصفتها حافظًا نظاميًا
            للبيانات الشخصية للمرشحين وتعالج تلك البيانات بدقة وفقًا للأنظمة
            السارية وسياسة الخصوصية وأغراض الخدمة الموثَّقة.
          </li>
          <li>
            لا يجوز تفسير أي بند في هذه الشروط على أنه ينقل ملكية البيانات
            الشخصية إلى أي طرف.
          </li>
        </ul>
        <h3 class="sub">
          <span class="n">11.2</span> مخرجات المنصة والبيانات المشتقة
        </h3>
        <p>
          ما لم يُنَص صراحةً على خلاف ذلك في اتفاقية كتابية، تحتفظ شركة الخبرات
          الصاعدة لتقنية المعلومات بجميع الحقوق والملكية والمصالح في المخرجات
          المولَّدة عبر المنصة والبيانات المشتقة، بما في ذلك التقييمات المولَّدة
          بالذكاء الاصطناعي والدرجات وعمليات التقويم والتقارير والرؤى المهيكلة
          وتنسيق وهيكلة السير الذاتية المخصَّصة وبيانات الاستخدام وسجلات النظام
          والبيانات المجمَّعة والمجهولة الهوية والتحسينات المشتقة من استخدام
          المنصة. ويجوز استخدام هذه البيانات المشتقة لتشغيل الخدمات وتأمينها
          وتحسينها.
        </p>
        <h3 class="sub">
          <span class="n">11.3</span> ترخيص الوصول إلى البيانات
        </h3>
        <p>
          يُمنَح العملاء ترخيصًا محدودًا وغير حصري وغير قابل للتحويل وقابلًا
          للإلغاء للوصول إلى البيانات والمخرجات عبر الخدمات حصرًا ولأغراض
          الأعمال الداخلية فقط. ولا يُمنَح أي حق في تصدير البيانات أو إعادة
          بيعها أو ترخيصها من الباطن أو استخلاصها أو إعادة استخدامها خارج
          الخدمات ما لم تصرّح شركة الخبرات الصاعدة لتقنية المعلومات بذلك كتابةً.
        </p>
      </section>
      <section id="analytics">
        <h2><span class="num">12</span> بيانات الاستخدام والتحليلات</h2>
        <p>
          يجوز لشركة الخبرات الصاعدة لتقنية المعلومات جمع ومعالجة بيانات تقنية
          وبيانات استخدام لتشغيل المنصة وتأمينها واستكشاف أخطائها وتحليلها
          وتحسينها. وقد يشمل ذلك تحليلات الزيارات والاستخدام، وتسجيلات الجلسات
          وبيانات التفاعل، ومقاييس الجهاز والمتصفح وعنوان
          <span class="en">IP</span> والأداء. وتُعالَج هذه البيانات وفقًا لنظام
          حماية البيانات الشخصية وسياسة الخصوصية.
        </p>
      </section>
      <section id="thirdparty">
        <h2><span class="num">13</span> خدمات الأطراف الثالثة</h2>
        <p>
          قد تعتمد الخدمات على خدمات أطراف ثالثة أو ترتبط بها، بما في ذلك
          معالجات الدفع ومزوّدي الاستضافة السحابية وأنظمة أصحاب العمل أو منصات
          التوظيف التي تُقدَّم إليها الطلبات. ولا تتحكّم شركة الخبرات الصاعدة
          لتقنية المعلومات في أي خدمة تابعة لطرف ثالث ولا تُقرّها ولا تتحمّل أي
          مسؤولية أو التزام عن محتواها أو توافرها أو سياساتها أو ممارساتها، بما
          في ذلك وجود الإعلانات الوظيفية أو دقتها أو حداثتها، أو ممارسات الفرز
          والتحقق لدى أصحاب العمل، أو قرارات التوظيف، أو تعامل تلك الأطراف مع
          البيانات الشخصية، ويكون وصولك إلى أي خدمة تابعة لطرف ثالث وتعاملك معها
          على مسؤوليتك وحدك وخاضعًا لشروط ذلك الطرف وسياساته التي تتحمل أنت
          مسؤولية الاطلاع عليها. وتُعالَج بيانات بطاقات الدفع بواسطة معالج الدفع
          التابع لطرف ثالث ولا تُخزَّن على خوادم شركة الخبرات الصاعدة لتقنية
          المعلومات.
        </p>
      </section>
      <section id="termination">
        <h2><span class="num">14</span> التعليق والإنهاء</h2>
        <p>
          يجوز لشركة الخبرات الصاعدة لتقنية المعلومات تعليق وصولك إلى الخدمات أو
          تقييده أو تعطيله أو إنهاؤه، كليًا أو جزئيًا، في أي وقت، بإشعار أو دون
          إشعار، ودون أي مسؤولية تجاهك، إذا: (1) أخللت بهذه الشروط، أو توافرت
          لدى شركة الخبرات الصاعدة لتقنية المعلومات أسباب معقولة، مدوَّنة وقتها،
          لاستنتاج أنك أخللت بها، وفي هذه الحالة يجوز لشركة الخبرات الصاعدة
          لتقنية المعلومات تعليق الوصول ريثما يُجرى التحقيق، ومتى رُفع ذلك
          التعليق لعدم ثبوت الإخلال، أُعيد إليك وصولك ومُدّد على النحو المبيَّن
          في آخر هذا القسم؛ أو (2) شكّل استخدامك للخدمات، في تقدير شركة الخبرات
          الصاعدة لتقنية المعلومات المعقول، خطرًا أمنيًا أو قانونيًا أو تنظيميًا
          أو تشغيليًا أو خطرًا على السمعة يمسّ شركة الخبرات الصاعدة لتقنية
          المعلومات أو الخدمات أو أي طرف ثالث؛ أو (3) اقتضت الأنظمة السارية أو
          أي جهة مختصة ذلك التعليق أو الإنهاء؛ أو (4) قررت شركة الخبرات الصاعدة
          لتقنية المعلومات إيقاف الخدمات أو أي جزء منها. ويمكنك إنهاء حسابك في
          أي وقت وفقًا للقسم 6.
        </p>
        <p>
          وعند أي إنهاء: (أ) تسقط فورًا جميع الحقوق والتراخيص الممنوحة لك بموجب
          هذه الشروط؛ (ب) يجب عليك التوقف فورًا عن أي وصول إلى الخدمات أو
          استخدام لها؛ (ج) يجوز لشركة الخبرات الصاعدة لتقنية المعلومات، مع
          مراعاة سياسة الخصوصية والأنظمة السارية، تعطيل حسابك وما يرتبط به من
          بيانات أو أرشفتها أو حذفها؛ (د) تظل سارية أحكام هذه الشروط التي تقتضي
          طبيعتها أو نصوصها الصريحة بقاءها بعد الإنهاء، بما فيها الأقسام 2 و7.2
          و7.3 و9 و11 و15 و16 و17 والأقسام من 19 إلى 25. وحيثما قامت شركة
          الخبرات الصاعدة لتقنية المعلومات بتعليق حسابك أو وصولك، أو تقييده، أو
          تعطيله، أو إنهائه، بموجب هذا القسم، لا يُحصَّل أي رسم تجديد آخر ما دام
          ذلك التعليق أو الإنهاء قائمًا، ويُعامَل الاشتراك، لأغراض الفوترة، على
          أنه منقضٍ اعتبارًا من نهاية فترة الفوترة الجارية آنذاك. وحيثما بدأ
          التعليق أو الإنهاء خلال فترة فوترة سبق أن حُصِّل عنها رسم منك، فإن
          الخدمة عن تلك الفترة كانت متاحة لك في لحظة ذلك الرسم، ويظل ذلك الرسم
          مستحقًا بالكامل ونهائيًا، ولا يُردّ منه شيء، ولا يُقيَّد رصيدًا، ولا
          يُجزَّأ، ولا يُمدَّد، وتنقضي جميع المخصّصات غير المستخدمة؛ ويسري ذلك
          أيًا كان سبب التعليق أو الإنهاء، فيما عدا الحالة المبيَّنة في الجملة
          التالية. وحيثما رُفع تعليق فُرض ريثما يُجرى التحقيق، وذلك لعدم ثبوت
          الإخلال، تعيد شركة الخبرات الصاعدة لتقنية المعلومات إليك وصولك وتمدّد
          فترة الفوترة المعنية بمقدار مدة التعليق؛ وذلك التمديد إعادة أداء
          للخدمة التي اشتريتها، وليس استردادًا ولا رصيدًا ولا تصحيحًا. وحيثما
          مارست شركة الخبرات الصاعدة لتقنية المعلومات الحق المنصوص عليه في
          الفقرة (4) أعلاه وأوقفت نهائيًا خدمة مدفوعة خلال فترة فوترة حُصِّل
          عنها رسم منك، تستمر شركة الخبرات الصاعدة لتقنية المعلومات في إتاحة تلك
          الخدمة لك، أو في إتاحة خدمة بديلة أو خلف لها من خدمات شركة الخبرات
          الصاعدة لتقنية المعلومات تختارها شركة الخبرات الصاعدة لتقنية
          المعلومات، لبقية تلك الفترة، بحيث تحصل على كامل فترة الفوترة التي
          اشتريتها، وتتوقف عن تحصيل رسوم تلك الخدمة اعتبارًا من نهاية تلك
          الفترة. وفيما عدا ما تقدّم في هذا القسم، لا يمنحك الإنهاء الحق في أي
          استرداد أو رصيد أو تعويض، إلا حيثما وبالقدر الذي تقتضيه الأنظمة
          السارية الإلزامية، ويكون الإنهاء دون إخلال بأي حقوق أو وسائل انتصاف أو
          التزامات أو مسؤوليات نشأت قبل تاريخه. ويحكم القسمان 5.6 و14.3 من سياسة
          الاسترداد التعليق والإنهاء وإيقاف الخدمة لأغراض الفوترة.
        </p>
      </section>
      <section id="disclaimers">
        <h2><span class="num">15</span> إخلاء المسؤولية عن الضمانات</h2>
        <p>
          إلى أقصى حد تسمح به الأنظمة السارية، تُقدَّم الخدمات والموقع
          الإلكتروني وجميع المخرجات "كما هي" و"حسب توافرها" و"بجميع عيوبها"، دون
          أي ضمانات أو شروط أو تعهدات أو التزامات من أي نوع، صريحة كانت أو ضمنية
          أو نظامية أو غير ذلك. ودون تقييد لعموم ما سبق، تُخلي شركة الخبرات
          الصاعدة لتقنية المعلومات ومرخِّصوها وموردوها مسؤوليتهم صراحةً عن أي
          وجميع الضمانات الضمنية المتعلقة بالقابلية للتسويق أو الجودة المُرضية
          أو الملاءمة لغرض معيّن أو الدقة أو الاكتمال أو الملكية أو الانتفاع
          الهادئ أو عدم الانتهاك، وأي ضمانات ناشئة عن مجرى التعامل أو مجرى
          الأداء أو العرف التجاري.
        </p>
        <p>
          ودون تقييد لما سبق، لا تضمن شركة الخبرات الصاعدة لتقنية المعلومات ولا
          تتعهد بأن: (أ) الخدمات ستكون دون انقطاع أو في الوقت المناسب أو آمنة أو
          خالية من الأخطاء أو من الفيروسات أو غيرها من المكوّنات الضارة، أو أن
          العيوب ستُصحَّح؛ (ب) بيانات المرشحين أو مطابقات الوظائف أو السير
          الذاتية المخصَّصة أو أي مخرجات أخرى ستكون دقيقة أو كاملة أو حديثة أو
          موثوقة؛ (ج) أي إعلان وظيفي يمكن الوصول إليه عبر الخدمات أو تستهدفه
          الخدمات قائم أو لا يزال متاحًا أو موصوف وصفًا صحيحًا؛ (د) استخدام
          الخدمات سيؤدي إلى تعيينات (للمشتركين) أو إلى مقابلات أو عروض عمل أو
          توظيف (للباحثين عن عمل). ولا تنشئ أي مشورة أو معلومات، شفهية كانت أو
          كتابية، تحصل عليها من شركة الخبرات الصاعدة لتقنية المعلومات أو عبر
          الخدمات أي ضمان غير منصوص عليه صراحةً في هذه الشروط.
        </p>
      </section>
      <section id="liability">
        <h2><span class="num">16</span> حدود المسؤولية واستبعادها</h2>
        <p>
          إلى أقصى حد تسمح به الأنظمة السارية، لا تتحمّل شركة الخبرات الصاعدة
          لتقنية المعلومات أو مسؤولوها أو مديروها أو موظفوها أو وكلاؤها أو
          مرخِّصوها أو موردوها، بأي حال من الأحوال، وسواء في إطار العقد أو
          المسؤولية التقصيرية (بما فيها الإهمال) أو الإخلال بواجب نظامي أو غير
          ذلك، المسؤولية عن: (أ) أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية
          أو زجرية أو عقابية؛ (ب) أي خسارة في الأرباح أو الإيرادات أو الوفورات
          المتوقعة؛ (ج) أي فقدان للعمل أو لفرص العمل أو للقدرة على الكسب؛ (د) أي
          فقدان للبيانات أو تلف أو إتلاف لها؛ (هـ) أي فقدان للاستخدام أو السمعة
          التجارية أو المكانة، أو أي خسارة أخرى غير ملموسة؛ (و) أي خسارة أو ضرر
          ينشأ عن أي مخرجات أو أي نتيجة مطابقة أو أي طلب أو تقديم (بما في ذلك أي
          طلب قُدِّم عبر التقديم التلقائي إلى وظيفة أو صاحب عمل أو جهة لم ترغب
          فيها أو لم تكن لتختارها بنفسك أو لم تراجعها بشكل فردي)، أو عن أي فعل
          أو امتناع من أي صاحب عمل أو منصة أو طرف ثالث آخر، أو عن أي اعتماد منك
          على أي مخرجات، أو فيما يتصل بأي مما سبق، وذلك في كل حالة فيما ينشأ عن
          هذه الشروط أو الخدمات أو الموقع الإلكتروني أو يتصل بها، حتى لو أُبلغت
          شركة الخبرات الصاعدة لتقنية المعلومات باحتمال وقوع تلك الخسارة أو ذلك
          الضرر.
        </p>
        <p>
          ودون تقييد لما سبق، وإلى أقصى حد تسمح به الأنظمة السارية، لا تتحمّل
          شركة الخبرات الصاعدة لتقنية المعلومات أي مسؤولية أيًا كانت عن: (أ) أي
          محتوى أو معلومات أو مواد تقدّمها أنت أو أي مستخدم آخر، بما في ذلك
          دقتها أو مشروعيتها أو اكتمالها؛ (ب) أفعال أي صاحب عمل أو مرشح أو مشترك
          أو باحث عن عمل أو منصة أو طرف ثالث آخر أو امتناعه أو قراراته أو سلوكه،
          بما في ذلك قرارات الفرز والمقابلات والتوظيف والتعامل مع أي طلب؛ (ج) أي
          فقدان أو تلف أو حذف للبيانات، إذ تقع على عاتقك وحدك مسؤولية الاحتفاظ
          بنسخ مستقلة من أي محتوى تقدّمه إلى الخدمات؛ (د) أي وصول غير مصرّح به
          إلى حسابك أو استخدام له ناتج كليًا أو جزئيًا عن أفعالك أو تقصيرك؛ (هـ)
          أي تعليق أو تعديل أو إيقاف أو عدم توافر للخدمات أو لأي جزء منها؛ (و)
          أي حدث أو ظرف مبيَّن في القسم 18 (القوة القاهرة).
        </p>
        <p>
          وإلى الحد الذي تسمح به الأنظمة السارية، لا يتجاوز إجمالي المسؤولية
          الكلية لشركة الخبرات الصاعدة لتقنية المعلومات وأطراف شركة الخبرات
          الصاعدة لتقنية المعلومات المعوَّضة (كما هي معرَّفة في القسم 17)
          مجتمعين، الناشئة عن هذه الشروط أو الخدمات أو الموقع الإلكتروني أو
          المتعلقة بها، أيًا كان منشؤها وأيًا كانت نظرية المسؤولية، بأي حال من
          الأحوال، مجموعَ المبالغ التي سدّدتها إلى شركة الخبرات الصاعدة لتقنية
          المعلومات خلال الاثني عشر (12) شهرًا السابقة للتاريخ الذي أُثيرت فيه
          المطالبة لأول مرة لدى شركة الخبرات الصاعدة لتقنية المعلومات. ولا يؤدي
          تعدد المطالبات إلى توسيع هذا الحد، وحيثما أثّرت مجموعة واحدة من الظروف
          في أكثر من رسم، خضعت تلك المطالبات لذلك الحد الإجمالي الواحد. وفيما
          يتعلق بأي مطالبة متعلقة بعملية خصم، يسري الحد المنصوص عليه في القسم
          5.9 من سياسة الاسترداد بدلًا من أي حد أدنى منه منصوص عليه في هذا
          القسم، وفقًا للقسم 1.8 من تلك السياسة. ولا يحدّ هذا القسم تصحيح عملية
          خصم بموجب القسم 10 من سياسة الاسترداد ولا يسري عليه، إذ إن ذلك التصحيح
          ليس دفعًا للعطل والضرر، كما لا يسري على أي التزام بردّ مبلغ قُبض بغير
          سبب مشروع.
        </p>
        <p>
          والحل الوحيد والحصري المتاح لك عن أي عدم رضا عن الخدمات أو عن أي
          مخرجات أو عن هذه الشروط هو التوقف عن استخدام الخدمات، والإلغاء وفقًا
          لهذه الشروط حيثما ينطبق. وتقرّ وتوافق على أن إخلاءات المسؤولية
          والاستثناءات والقيود المبيَّنة في هذه الشروط تمثّل توزيعًا عادلًا
          ومعقولًا للمخاطر بينك وبين شركة الخبرات الصاعدة لتقنية المعلومات في
          ضوء طبيعة الخدمات وأسعارها، وتشكّل أساسًا جوهريًا للاتفاق بين الطرفين،
          وتسري حتى في حال إخفاق الغرض الأساسي لأي وسيلة انتصاف محدودة.
        </p>
        <p>
          وإلى الحد الذي تسمح به الأنظمة السارية، يجب رفع أي مطالبة أو دعوى قد
          تكون لك ناشئة عن هذه الشروط أو الخدمات أو الموقع الإلكتروني أو متعلقة
          بها خلال اثني عشر (12) شهرًا من تاريخ نشوء سبب الدعوى لأول مرة، وإلا
          سقطت تلك المطالبة أو الدعوى وعُدّت متنازلًا عنها نهائيًا. ولا يوجد في
          هذه الشروط ما يستبعد أو يحدّ من أي مسؤولية لا يجوز استبعادها أو
          تحديدها بموجب الأنظمة السعودية السارية، بما في ذلك المسؤولية الناشئة
          عن الغش أو سوء السلوك المتعمد، وتُفسَّر هذه الشروط وفقًا لذلك.
        </p>
      </section>
      <section id="indemnification">
        <h2><span class="num">17</span> التعويض</h2>
        <p>
          توافق على تعويض شركة الخبرات الصاعدة لتقنية المعلومات ومسؤوليها
          ومديريها وموظفيها ووكلائها ومرخِّصيها ومورديها ("أطراف شركة الخبرات
          الصاعدة لتقنية المعلومات المعوَّضة") والدفاع عنهم وإبراء ذمتهم من وضد
          أي وجميع المطالبات والطلبات والدعاوى والإجراءات والمسؤوليات والأضرار
          والخسائر والتكاليف والمصاريف (بما فيها أتعاب المحاماة المعقولة وتكاليف
          التحقيق) الناشئة عن أي مما يلي أو المتصلة به بأي شكل: (أ) وصولك إلى
          الخدمات أو الموقع الإلكتروني أو استخدامك لهما؛ (ب) إخلالك أو إخلالك
          المزعوم بهذه الشروط أو بأي نظام سارٍ؛ (ج) أي محتوى أو بيانات أو
          معلومات تقدّمها إلى الخدمات أو عبرها، بما في ذلك أي معلومات غير دقيقة
          أو غير مكتملة أو مضلّلة أو غير مشروعة في السيرة الذاتية أو الملف أو
          الطلب؛ (د) أي طلب قُدِّم نيابةً عنك وفقًا لتفويضك المبيَّن في القسم
          7.1؛ (هـ) انتهاكك لأي حق لأي شخص أو كيان آخر. وتحتفظ شركة الخبرات
          الصاعدة لتقنية المعلومات بالحق في أن تتولى، على نفقتك، الدفاع الحصري
          وإدارة أي مسألة تخضع للتعويض من جانبك، وفي هذه الحالة توافق على
          التعاون الكامل مع شركة الخبرات الصاعدة لتقنية المعلومات في التمسك بأي
          دفوع متاحة، ولا يجوز لك تسوية أي مسألة من هذا القبيل دون موافقة كتابية
          مسبقة من شركة الخبرات الصاعدة لتقنية المعلومات.
        </p>
      </section>
      <section id="force-majeure">
        <h2><span class="num">18</span> القوة القاهرة</h2>
        <p>
          لا تُعدّ شركة الخبرات الصاعدة لتقنية المعلومات مخلّة بهذه الشروط، ولا
          تتحمّل المسؤولية عن أي إخفاق أو تأخير في تنفيذ أي من التزاماتها
          بموجبها، بالقدر الذي ينشأ فيه ذلك الإخفاق أو التأخير عن أي فعل أو حدث
          أو امتناع أو ظرف خارج عن سيطرتها المعقولة أو يُعزى إليه (يُشار إلى كل
          منها بـ"حدث القوة القاهرة")، بما في ذلك القضاء والقدر والفيضانات
          والجفاف والزلازل وغيرها من الكوارث الطبيعية؛ والأوبئة والجوائح؛
          والهجمات الإرهابية والحروب الأهلية والاضطرابات المدنية وأعمال الشغب؛
          والحروب والنزاعات المسلحة؛ وفرض العقوبات أو الحظر أو قطع العلاقات
          الدبلوماسية؛ وأي نظام أو أي إجراء تتخذه حكومة أو جهة عامة؛ وانهيار
          المباني والحرائق والانفجارات والحوادث؛ وأي نزاع عمالي أو تجاري أو
          إضراب أو إجراء نقابي أو إغلاق؛ وانقطاع خدمات المرافق أو شبكات
          الاتصالات أو البنية التحتية للاستضافة أو خدمات الأطراف الثالثة أو
          تدهورها أو تعطلها؛ وأي هجوم لحجب الخدمة أو غيره من الهجمات الخبيثة.
          وأثناء استمرار حدث القوة القاهرة، تُعلَّق التزامات شركة الخبرات
          الصاعدة لتقنية المعلومات المتأثرة به، وتبذل شركة الخبرات الصاعدة
          لتقنية المعلومات جهودًا معقولة تجاريًا للتخفيف من آثاره.
        </p>
      </section>
      <section id="severability">
        <h2><span class="num">19</span> قابلية الفصل؛ عدم التنازل</h2>
        <p>
          إذا أصبح أي حكم من أحكام هذه الشروط أو أي جزء منه باطلًا أو غير مشروع
          أو غير قابل للإنفاذ في أي اختصاص قضائي، فيُعدّ ذلك الحكم أو الجزء،
          بالقدر اللازم، معدَّلًا بالحد الأدنى الضروري لجعله صحيحًا ومشروعًا
          وقابلًا للإنفاذ، وإذا تعذّر ذلك التعديل، عُدّ الحكم أو الجزء المعني
          محذوفًا؛ ولا يؤثر أي تعديل أو حذف من هذا القبيل في صحة بقية أحكام هذه
          الشروط أو مشروعيتها أو قابليتها للإنفاذ، وتظل تلك الأحكام نافذة بكامل
          قوتها وأثرها. ولا يُعدّ أي إخفاق أو تأخير من شركة الخبرات الصاعدة
          لتقنية المعلومات في ممارسة أي حق أو صلاحية أو وسيلة انتصاف بموجب هذه
          الشروط أو بموجب النظام تنازلًا عن ذلك الحق أو عن أي حق أو صلاحية أو
          وسيلة انتصاف أخرى، ولا تحول أي ممارسة منفردة أو جزئية لأي حق أو صلاحية
          أو وسيلة انتصاف دون أي ممارسة أخرى لها أو ممارسة أي حق أو صلاحية أو
          وسيلة انتصاف أخرى. ولا يكون التنازل نافذًا إلا إذا صدر صراحةً وكتابةً.
        </p>
      </section>
      <section id="assignment">
        <h2><span class="num">20</span> التنازل</h2>
        <p>
          لا يجوز لك التنازل عن أي من حقوقك أو التزاماتك بموجب هذه الشروط أو
          جميعها أو نقلها أو الترخيص بها من الباطن أو رهنها أو التعاقد عليها من
          الباطن أو تفويضها أو التصرف فيها بأي شكل آخر دون موافقة كتابية مسبقة
          من شركة الخبرات الصاعدة لتقنية المعلومات، ويُعدّ أي تنازل أو نقل مزعوم
          بالمخالفة لهذا القسم باطلًا ولاغيًا. ويجوز لشركة الخبرات الصاعدة
          لتقنية المعلومات في أي وقت التنازل عن أي من حقوقها والتزاماتها بموجب
          هذه الشروط أو جميعها أو نقلها أو رهنها أو التعاقد عليها من الباطن أو
          تفويضها أو التصرف فيها بأي شكل آخر، بما في ذلك في سياق أي اندماج أو
          استحواذ أو إعادة هيكلة مؤسسية أو بيع لجميع أصولها أو معظمها، دون
          موافقتك ودون إشعارك. وتكون هذه الشروط ملزمة للطرفين ولخلفائهما
          والمتنازَل لهم المصرَّح لهم، وتنصرف منفعتها إليهم.
        </p>
      </section>
      <section id="notices">
        <h2><span class="num">21</span> الإشعارات والمراسلات الإلكترونية</h2>
        <p>
          توافق على تلقّي المراسلات من شركة الخبرات الصاعدة لتقنية المعلومات
          إلكترونيًا، بما في ذلك عبر البريد الإلكتروني المرتبط بحسابك، أو عبر
          الرسائل أو الإشعارات أو التنبيهات داخل الخدمات، أو عبر النشر على
          الموقع الإلكتروني، وتوافق على أن جميع الاتفاقيات والإشعارات والإفصاحات
          وغيرها من المراسلات التي تقدّمها لك شركة الخبرات الصاعدة لتقنية
          المعلومات إلكترونيًا تفي بأي متطلب نظامي يقضي بأن تكون تلك المراسلات
          كتابية. وتوجَّه الإشعارات إلى شركة الخبرات الصاعدة لتقنية المعلومات
          كتابةً بتقديم تذكرة دعم عبر
          <a routerLink="/contact-us">https://uptal.com/contact-us</a>، مع
          اختيار سبب التواصل "الفوترة والمدفوعات" متى كانت المسألة متعلقة بعملية
          خصم، وتُعدّ مستلَمة في تاريخ استلام نظام تذاكر الدعم لدى شركة الخبرات
          الصاعدة لتقنية المعلومات لها، وتكون سجلات التذاكر لدى شركة الخبرات
          الصاعدة لتقنية المعلومات بيّنةً على ذلك التاريخ. ولا يُعدّ إشعارًا
          لأغراض هذه الشروط أيٌّ مما يلي: البريد الإلكتروني المرسَل إلى أي
          عنوان، أو رسائل وسائل التواصل الاجتماعي، أو الرسائل المرسَلة عبر أي
          تطبيق مراسلة، أو المحادثة داخل المنتج، أو المكالمات الهاتفية، أو
          الرسائل الموجَّهة إلى أفراد من الموظفين أو المسؤولين أو الوكلاء أو
          المتعاقدين أو الممثلين؛ ولا يترتب على أي منها بدء أي مدة بموجب هذه
          الشروط، ولا وقفها، ولا تمديدها، ولا استيفاؤها، وذلك فيما عدا ما تنص
          عليه سياسة الاسترداد صراحةً على خلاف ذلك، وعلى الأخص القسم 12.6 منها،
          الذي يُعدّ بموجبه الإخطار الكتابي الموجَّه بوسيلة أخرى وتتسلمه شركة
          الخبرات الصاعدة لتقنية المعلومات فعليًا إخطارًا صحيحًا متى كان نظام
          تذاكر الدعم غير متاح لك، والقسم 9.7 منها، الذي تُعدّ بموجبه المطالبة
          بموجب ضمان تحسّن الدرجة المُلغى، المرسَلة إلى عنوان البريد الإلكتروني
          المُلغى خلال المدة المبيَّنة في ذلك القسم، مطالبةً مقدَّمة تقديمًا
          صحيحًا، والقسم 15.11 منها، الذي يجوز بموجبه الإخطار بوفاة المشترك بأي
          وسيلة. وتقديم التذكرة ليس إلغاءً للاشتراك؛ فالإلغاء لا يتم إلا
          بالكيفية المبيَّنة في القسم 6.1. وأنت المسؤول عن إبقاء بيانات التواصل
          الخاصة بك دقيقة وحديثة، ويُعدّ أي إشعار ترسله شركة الخبرات الصاعدة
          لتقنية المعلومات إلى أحدث بريد إلكتروني مرتبط بحسابك مُبلَّغًا على
          الوجه الصحيح سواء استلمته أو قرأته فعليًا أم لا.
        </p>
      </section>
      <section id="language">
        <h2><span class="num">22</span> اللغة</h2>
        <p>
          أُعدّت هذه الشروط ونُشرت باللغتين العربية والإنجليزية، ويُقصَد أن يكون
          لكل نسخة المعنى والأثر ذاتهما. وفي حال وجود أي تعارض أو غموض أو عدم
          اتساق بين النسختين العربية والإنجليزية، تسود النسخة العربية بالقدر
          الذي تقتضيه الأنظمة السارية، وفيما عدا ذلك تُقرأ النسختان وتُفسَّران،
          قدر الإمكان، على نحو متسق فيما بينهما.
        </p>
      </section>
      <section id="survival">
        <h2>
          <span class="num">23</span> البقاء؛ كامل الاتفاق؛ عدم وجود حقوق للغير
        </h2>
        <p>
          تظل سارية بعد انقضاء هذه الشروط أو إنهائها الأحكام التي تقتضي طبيعتها
          أو نصوصها الصريحة بقاءها، بما فيها الأحكام المحدّدة في القسم 14.
          وتشكّل هذه الشروط، مع الوثائق المدمجة بالإشارة في القسم 1، كامل
          الاتفاق والتفاهم بينك وبين شركة الخبرات الصاعدة لتقنية المعلومات فيما
          يتعلق بموضوعها وبالخدمات، وتحلّ محل جميع الاتفاقيات والوعود والتأكيدات
          والضمانات والإقرارات والمقترحات والتفاهمات السابقة والمتزامنة بين
          الطرفين، كتابية كانت أو شفهية، فيما يتعلق بذلك الموضوع، وتُلغيها؛ على
          ألا يُفسَّر أي مما ورد في هذا القسم على أنه يحدّ أو يستبعد أي مسؤولية
          عن الاحتيال. وتقرّ بأنك، بإبرامك هذه الشروط، لا تعتمد على أي بيان أو
          إقرار أو تأكيد أو ضمان (سواء صدر ببراءة أو بإهمال) غير منصوص عليه في
          هذه الشروط. وباستثناء ما تنص عليه هذه الشروط صراحةً، لا يكون لأي شخص
          غيرك وغير شركة الخبرات الصاعدة لتقنية المعلومات أي حق في إنفاذ أي من
          هذه الشروط.
        </p>
      </section>
      <section id="law">
        <h2><span class="num">24</span> القانون الحاكم والاختصاص القضائي</h2>
        <p>
          تخضع هذه الشروط لأنظمة المملكة العربية السعودية وتُفسَّر وفقًا لها،
          دون إعمال أي مبادئ لتنازع القوانين. وتوافق على أن أي دعوى تنشأ عن هذه
          الشروط أو عن استخدامك للخدمات أو تتعلق بهما تُرفَع حصرًا أمام المحاكم
          المختصة في مدينة الرياض بالمملكة العربية السعودية، وتقرّ بموجبه بقبولك
          وخضوعك للاختصاص القضائي لتلك المحاكم.
        </p>
      </section>
      <section id="changes">
        <h2><span class="num">25</span> التغييرات على هذه الشروط</h2>
        <p>
          تحتفظ شركة الخبرات الصاعدة لتقنية المعلومات بالحق في تعديل هذه الشروط
          أو تحديثها في أي وقت. وتُنشَر الشروط المحدَّثة على الموقع الإلكتروني
          وتسري فور نشرها. ويُعدّ استمرارك في استخدام الخدمات بعد أي تغييرات
          قبولًا للشروط المحدَّثة. وإذا لم توافق على الشروط المحدَّثة، فيجب عليك
          التوقف عن استخدام الخدمات. ولا تتحمّل شركة الخبرات الصاعدة لتقنية
          المعلومات أي مسؤولية تجاهك أو تجاه أي طرف ثالث عن أي تعديل لهذه الشروط
          أو عن أي تعديل أو تعليق أو إيقاف للخدمات.
        </p>
      </section>
      <section id="contact">
        <h2><span class="num">26</span> التواصل</h2>
        <p>
          إذا كانت لديك أي أسئلة حول هذه الشروط، فيُرجى التواصل معنا بتقديم
          تذكرة دعم عبر
          <a routerLink="/contact-us">https://uptal.com/contact-us</a>، مع
          اختيار سبب التواصل "الفوترة والمدفوعات" متى كانت المسألة متعلقة بعملية
          خصم. آخر تحديث في 7 سبتمبر 2026.
        </p>
      </section>
    </article>
  </div>
</div>

<main-footer></main-footer>
